import React, { useEffect } from "react";
import anime from "animejs";

const SVG = () => {
  let animation = () => {
    anime({
      targets: ".st0, .st1",
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: "cubicBezier(.5, .05, .1, .3)",
      duration: 1000,
      delay: function (el, i) {
        return i * 250;
      },
    });
  };
  useEffect(() => {
    animation();
  }, []);
  return (
    <div>
      <svg
        className="svg"
        viewBox="0 0 800 800"
        style={{ fill: "none", stroke: "red" }}
      >
        <g id="bg"></g>
        <g id="graphic">
          <g>
            <path
              className="st0"
              d="M363.8,298.1c-9.8-15-16.2-32.6-16.4-50.4c-0.2-14.1,15.1-22.5,24.9-30.5c10-8.1,20.2-16,30.6-23.7
  c42.8-31.7,88.9-59.4,138.7-78.7c26.9-10.4,55.4-19.8,84.6-18.7c2.5,0.1,2.8-3.7,0.3-3.8c-26.2-1.1-51.6,6.2-76.1,15
  c-27.7,10-54.3,22.6-79.8,37.2c-25.1,14.3-49.1,30.3-72.2,47.6c-11.7,8.7-23.1,17.7-34.4,26.9c-8.9,7.2-19.8,13.9-20.5,26.5
  c-1.4,26.8,13.4,56.2,33.4,72.9c0.8,0.7,1.9-0.1,2.1-1C372.9,311.9,367.5,305.6,363.8,298.1z"
            />
            <path
              className="st0"
              d="M462.3,334.2c10.9-9.7,21.5-19.6,31.9-29.8c20.6-20.2,40.2-41.4,58.3-63.9c18.4-22.9,35-47.3,49.2-73
  c12.5-22.8,23.7-46.7,26.7-72.8c0.3-2.5-3.5-2.7-3.8-0.3c-3.4,29-17.2,55.7-31.7,80.6c-26.9,46.1-61.5,87.3-99.5,124.7
  c-9.2,9-18.6,17.9-28.2,26.5c-9.4,8.5-20.1,22.3-34,19.9c-17.9-3.1-34.7-12.5-48.1-24.9c-6.1-5.1-11.7-10.7-16.1-17.2
  c-0.8,0.2-1.5,1.1-1,1.9c13.4,22.4,40.1,41.6,66.8,44.4C445.4,351.6,453.7,341.8,462.3,334.2z"
            />
            <path
              className="st0"
              d="M396.8,333.1c-17.4-13.5-31.3-30.9-42.9-49.4c-0.2-0.3-0.7-0.2-0.6,0.2c2.5,10.8,9.7,20.5,17,28.6
  c7.4,8.2,15.6,17.3,25.7,22.2C396.9,335.1,397.5,333.6,396.8,333.1z"
            />
            <path
              className="st0"
              d="M579.7,198.8c-14.8-9.8-28.5-20.5-40-34c-5.7-6.6-10.8-13.7-15.3-21.1c-4-6.6-5.5-12.2-6.4-19.8
  c0-0.1-0.1-0.1-0.1,0c-3.9,3.9-2.2,9.8-0.4,14.4c3.4,8.4,9.2,16.3,14.7,23.5c12.2,15.9,27.9,30.4,45.7,39.9
  C579.7,202.5,581.6,200,579.7,198.8z"
            />
            <path
              className="st0"
              d="M523.8,232.5c6.8-19.7-6.8-44.5-26.3-51.5c-10.5-5.4-23.8-4.5-35.5,1.5c-17.7,9-26.8,28-21.7,47.4
  C450.9,269,510.6,271.1,523.8,232.5z M461.1,251.4c-17.2-10.1-23.8-34.4-13.1-51.5c8.7-13.8,29.8-22.7,46.1-18.2
  c0.1,0.1,0.2,0.2,0.4,0.3c5.6,2.3,11,6.8,15.5,12c0.2,0.4,0.4,0.7,0.6,1.1c0.1,0.2,0.3,0.2,0.4,0.1c3.3,4,6.1,8.4,8,12.5
  c4.7,10.1,3.4,21.7-2.6,31C505,256.7,479.3,262,461.1,251.4z"
            />
            <path
              className="st0"
              d="M360.8,342.2c-12.3-11.6-22.5-25.4-28.7-41.1c-3-7.5-6.5-17-6.5-25.3c0-6.5,3-7.3,8.2-9.2
  c3.8-1.4,7.6-2.8,11.4-4.3c0.2,0.6,0.3,1.2,0.5,1.8c0.2,0.7,1.4,1.1,1.6,0.1c0.3-1.5,0.6-2.7,0.8-4.2c0.2-1-1-2.2-2-1.8
  c-5.4,1.7-10.8,3.7-16.1,5.7c-2.9,1.1-6.4,2-7.9,5.1c-1.4,2.8-0.4,6.8,0,9.7c0.8,5.5,2,10.9,3.7,16.2c6,19.3,17.4,36.6,33.4,49.2
  C360.2,345,361.9,343.2,360.8,342.2z"
            />
            <path
              className="st0"
              d="M339.9,317.7c9.5,14,21.5,26.1,36.1,34.8c7,4.1,15.8,9,24,10.3c6.4,1,7.6-1.8,10.4-6.6
  c2-3.5,3.9-7.1,6.1-10.5c-0.6-0.2-1.2-0.5-1.7-0.7c-0.7-0.3-0.8-1.6,0.1-1.6c1.5-0.1,2.8-0.1,4.3-0.1c1,0,2,1.3,1.5,2.3
  c-2.5,5.1-5.4,10.1-8.2,15c-1.5,2.7-3,6-6.2,7c-3,0.9-6.8-0.7-9.6-1.5c-5.3-1.6-10.5-3.7-15.5-6.2c-18.2-9-33.5-22.9-43.3-40.7
  C337,317.8,339,316.5,339.9,317.7z"
            />
            <path
              className="st0"
              d="M466,145.9c-9.1-3.7-19.8-9.8-29.8-10.4c-9.5-0.6-20.4,4.3-29.2,7.3c-22.8,7.7-44.7,18.1-65.2,30.8
  c-9.5,5.9-18.7,12.3-27.6,19.2c-5.2,4-10.2,8.1-15.1,12.5c-2,1.8-5,3.9-5.3,6.9c-0.8,8,13.9,9.6,19,10.7
  c12.7,2.9,25.5,5.8,38.2,8.6c2.5,0.6,3.8-3.2,1.3-3.7c-10.2-2.3-20.4-4.6-30.6-6.9c-4.6-1-9.3-2-13.9-3.2
  c-1.6-0.4-4.8-0.8-6.1-1.9c-5.4-4.6-1.1-6.7,1.7-9.1C319,193,336,181,353.9,170.8c17-9.7,35-17.8,53.5-24.1c8.7-3,20.6-8.5,30-7.1
  c8.4,1.3,17,5.7,25,8.9c-1.3,2.1-3.1,5-2.7,4.5c-0.2,0.2,0.1,0.6,0.3,0.4c-0.8,0.8,6-4.1,6.4-4.4
  C467.8,148.2,467.2,146.4,466,145.9z"
            />
            <path
              className="st0"
              d="M549.8,244c2.2,9.6,6.6,21.1,5.7,31.1c-0.9,9.5-7.4,19.5-11.8,27.7c-11.2,21.3-24.8,41.4-40.6,59.6
  c-7.3,8.5-15.1,16.6-23.2,24.2c-4.8,4.5-9.6,8.8-14.7,12.9c-2.1,1.7-4.7,4.3-7.6,4.1c-8-0.4-7.3-15.2-7.6-20.5
  c-0.9-13-1.7-26.1-2.6-39.1c-0.2-2.5,3.7-3.2,3.9-0.7c0.7,10.4,1.4,20.9,2,31.3c0.3,4.7,0.5,9.5,1,14.2c0.2,1.6,0,4.8,0.9,6.3
  c3.7,6.1,6.4,2.1,9.2-0.2c15.8-13.3,30.3-28.1,43.2-44.3c12.2-15.3,23-31.8,32.2-49.1c4.3-8.1,11.6-19,11.7-28.6
  c0.1-8.5-3-17.7-4.9-26.1c-2.3,1-5.4,2.3-4.9,2c-0.3,0.2-0.6-0.2-0.3-0.4c-0.9,0.6,4.9-5.3,5.3-5.7
  C547.8,241.9,549.5,242.7,549.8,244z"
            />
            <path
              className="st0"
              d="M505.6,241.3c9.8-9.5,12-25.8,5.3-37.6c-5.3-9.4-15-14.6-25.1-14.9c-12.9-0.9-26,4.9-32.4,16.5
  c-8,14.4-2,30,10,40C475.1,255.2,495.1,251.4,505.6,241.3z M487.8,247.2c-9.9,2.1-18.7,0.4-25.8-7.2c-6.1-6.5-10.5-14.5-9.5-23.7
  c1.5-13.3,11.3-20.8,22.7-24.1c13.8-3.5,29.9,3,34.9,17C516.4,226.4,505.1,243.5,487.8,247.2z"
            />
            <path
              className="st0"
              d="M511.7,211.7c-8.1-1.4-17.3-0.9-25.6-0.3c-0.4,0-0.3,0.5,0,0.6c8.1,1.6,17.4,2.9,25.7,2.3
  C513.4,214.1,513,212,511.7,211.7z"
            />
            <path
              className="st0"
              d="M511.4,221.7c-5.3,0.4-10.5-1.6-15.8-0.9c-0.4,0-0.5,0.7-0.1,0.8c3,0.8,6,1.4,8.9,2.1
  c2.4,0.6,4.9,1.1,7.4,0.8C513.7,224.3,513.2,221.6,511.4,221.7z"
            />
            <path
              className="st0"
              d="M482.5,221.1c-0.1-0.1-0.2,0-0.1,0.1C482.4,221.3,482.6,221.1,482.5,221.1z"
            />
            <path
              className="st0"
              d="M482.2,221.5c-10-1.6-20-3.9-30.1-4.9c-1.8-0.2-2.5,2.7-0.7,3.1c9.9,2.5,20.5,2.9,30.7,2.7
  C482.8,222.4,482.8,221.6,482.2,221.5z"
            />
            <path
              className="st0"
              d="M464.5,210.3c-1.1-1.3-3.5-1.5-5-1.8c-2-0.4-4.1-0.7-6.1-0.6c-1.9,0.1-1.8,2.9,0.1,2.7
  c2.1-0.2,4.1-0.4,6.2-0.3C461.2,210.2,463.1,210.8,464.5,210.3C464.6,210.3,464.6,210.3,464.5,210.3z"
            />
            <path
              className="st0"
              d="M624.4,99.2c-5.2-2-10.6-3.7-16.1-4.3c-0.5-0.1-0.6,0.6-0.2,0.8c0,0,0,0,0,0c5.5,1.5,10.9,3,16.1,5.2
  C624.4,100.2,624.4,99.7,624.4,99.2z"
            />
            <path
              className="st0"
              d="M624.3,102c-7.2-2.8-14.5-5-22-6.7c-0.6,0.2-1.2,0.4-1.8,0.5c0.1,0.1,0.2,0.2,0.3,0.3
  c8.1,1.8,15.9,4.5,23.5,7.7C624.3,103.2,624.3,102.6,624.3,102z"
            />
            <path
              className="st0"
              d="M620.9,103.4c-6.8-3.2-14.2-5.5-21.5-7.2c-0.5,0.1-1.1,0.3-1.6,0.4c7.8,2.1,15.2,5,22.7,8.2
  C621.3,105.2,621.8,103.8,620.9,103.4z"
            />
            <path
              className="st0"
              d="M619.9,106.4c-8.1-3.7-16.4-6.7-24.9-9.1c-0.8,0.2-1.5,0.3-2.3,0.5c9.1,2.7,18,6,26.7,10.1
  C620.3,108.3,620.8,106.8,619.9,106.4z"
            />
            <path
              className="st0"
              d="M620.2,110.8c-11.6-4.6-23.4-8.4-35.5-11.5c-0.8,0.2-1.7,0.3-2.5,0.5c12.8,3.4,25.2,7.5,37.5,12.5
  C620.6,112.7,621.2,111.1,620.2,110.8z"
            />
            <path
              className="st0"
              d="M621.2,114.6c-14-5.9-28.5-10.5-43.3-14c-0.3,0.1-0.7,0.2-1,0.2c15,3.8,29.6,8.9,43.8,15.3
  C621.6,116.6,622.2,115.1,621.2,114.6z"
            />
            <path
              className="st0"
              d="M618.8,116.2c-15.3-5.9-31-10.4-47-13.8c-0.5,0.3-1.1,0.5-1.7,0.7c16.4,3.7,32.4,8.7,48.2,14.8
  C619.3,118.3,619.8,116.6,618.8,116.2z"
            />
            <path
              className="st0"
              d="M617.3,118.7c-16.8-6.8-34.3-11.6-52.2-14.6c-0.6,0.2-1.2,0.4-1.8,0.6c18.4,3.2,36.2,8.4,53.4,15.7
  C617.8,120.9,618.4,119.1,617.3,118.7z"
            />
            <path
              className="st0"
              d="M619.1,124.3c-19.7-7.3-39.8-13.3-60.3-17.8c-0.6,0.3-1.2,0.6-1.8,0.8c20.9,4.8,41.4,11,61.4,18.8
  C619.6,126.6,620.2,124.8,619.1,124.3z"
            />
            <path
              className="st0"
              d="M611.4,128.7c-18.5-8.6-38.2-15.5-58.3-19.4c-0.5,0.3-1.1,0.6-1.6,0.8c-0.2,0.1-0.3,0.1-0.5,0.2
  c20.5,5.4,40.3,11.8,59.7,20.6C612,131.6,612.7,129.4,611.4,128.7z"
            />
            <path
              className="st0"
              d="M614.6,135.1c-22.2-10.2-45.5-17.6-69.4-22.2c-0.5,0.2-1.1,0.4-1.6,0.7c24.3,5,47.9,12.8,70.3,23.5
  C615.1,137.7,615.8,135.7,614.6,135.1z"
            />
            <path
              className="st0"
              d="M612.7,142.7c0.2-0.3,0.5-0.6,0.8-0.9c-0.1-0.2-0.2-0.5-0.5-0.6c-23.8-11.1-49.3-20.2-75.1-25.6
  c-0.6,0.2-1.1,0.4-1.7,0.5c26.5,6,51,16.7,76.2,26.8c0.1,0,0.1,0,0.2,0C612.5,142.9,612.6,142.8,612.7,142.7z"
            />
            <path
              className="st0"
              d="M611.5,144.6c-27-11-54.7-20.9-83.5-26c-0.6,0.2-1.2,0.3-1.7,0.5c29.2,5.2,56.7,16.1,84.1,27.3
  C610.7,145.7,611.1,145.1,611.5,144.6z"
            />
            <path
              className="st0"
              d="M608.8,148.9c-29.6-12-59.7-23.2-91.5-27.3c-0.5,0.2-1.1,0.3-1.6,0.5c32,4.6,62.3,16.3,92,28.7
  C608.1,150.1,608.5,149.5,608.8,148.9z"
            />
            <path
              className="st0"
              d="M606.3,153.6c-29.8-12.9-60.4-24.2-92.1-30.9c0.2,0.5,0.4,1,0.6,1.5c31.3,7.1,61,19,90.5,31.6
  C605.6,155.1,605.9,154.3,606.3,153.6z"
            />
            <path
              className="st0"
              d="M604,158.4c-27.9-11.9-56.9-22.5-86.9-27.7c0.2,0.5,0.3,1,0.5,1.6c29.7,5.6,57.4,17,85.4,28.2
  C603.3,159.8,603.6,159.1,604,158.4z"
            />
            <path
              className="st0"
              d="M603.1,160.3c-27-10.5-54.9-19.7-83.5-24.1c-1-0.1-1.1,1.4-0.1,1.5c28.7,4.7,55.6,14.7,82.7,24.7
  C602.5,161.6,602.8,160.9,603.1,160.3z"
            />
            <path
              className="st0"
              d="M600.5,165.8C600.5,165.8,600.5,165.8,600.5,165.8c-25.9-10.7-53.1-18.7-80.5-24.6c0.1,0.3,0.3,0.6,0.4,0.9
  c0.2,0.3,0.4,0.7,0.5,1c26.9,6.1,52.9,14.5,78.6,24.6C599.9,167,600.2,166.4,600.5,165.8z"
            />
            <path
              className="st0"
              d="M598.8,169.1c-24.7-9.5-50.2-16.8-76-22.6c0.3,0.5,0.6,1.1,0.9,1.6c25.3,6,49.9,13.8,74.2,22.8
  C598.3,170.3,598.6,169.7,598.8,169.1z"
            />
            <path
              className="st0"
              d="M596.1,174.9c-22.4-9.6-46-16.8-69.6-22.6c0.4,0.6,0.9,1.3,1.3,1.9c23,5.9,45.1,13.8,67.1,22.5
  C595.4,176.1,595.7,175.5,596.1,174.9z"
            />
            <path
              className="st0"
              d="M593.6,178.7c0.1-0.5,0-1-0.6-1.2c-20.3-8-41.4-14.4-62.5-19.8c0.5,0.6,1,1.2,1.5,1.8
  c20.5,5.6,40.5,12.5,60.4,19.9c0.4,0.1,0.7,0,0.9-0.1C593.4,179.1,593.5,178.9,593.6,178.7z"
            />
            <path
              className="st0"
              d="M539.5,167.5c16.1,4.4,31.8,9.6,47.5,15.3c1.1,0.4,1.7-1.3,0.6-1.8c-16.3-6.2-33.1-11.2-50-15.4
  C538.2,166.2,538.9,166.8,539.5,167.5z"
            />
            <path
              className="st0"
              d="M589.3,185.2c-14.7-5.1-29.9-9.4-45-13.2c0.8,0.8,1.6,1.5,2.5,2.3c13.9,3.8,27.7,8.1,41.5,12.4
  C588.6,186.2,588.9,185.7,589.3,185.2z"
            />
            <path
              className="st0"
              d="M551.8,179.1c11.1,3.4,22,7.2,32.9,11c1.2,0.4,1.9-1.4,0.7-1.9c-11.9-4.5-24.1-8.3-36.3-11.7
  C549.9,177.3,550.9,178.2,551.8,179.1z"
            />
            <path
              className="st0"
              d="M584.8,191.9c-9.3-3-18.8-5.6-28.3-8.1c0.7,0.7,1.4,1.4,2.1,2c8.4,2.5,16.8,5.1,25.2,7.7
  C584.1,193,584.5,192.5,584.8,191.9z"
            />
            <path
              className="st0"
              d="M582.5,196c-6.6-2.4-13.4-4.6-20.2-6.7c1,0.9,2.1,1.9,3.2,2.8c5.5,1.8,11,3.8,16.4,5.7
  C582,197.1,582.2,196.6,582.5,196z"
            />
            <path
              className="st0"
              d="M348.6,267.8c-3.2-1.1-6.6-1.8-10-2.2c-1.7-0.2-5.6-1.4-6.9,0.1c-0.2,0.2-0.1,0.5,0,0.7
  c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.3,0.2,0.5,0.2c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.2,0.3-0.4c0,0,0,0,0,0c0.4,0.1,0.8,0.2,0.8,0.2
  c0.7,0.1,1.5,0.2,2.2,0.2c1.3,0.2,2.6,0.4,3.9,0.6c2.8,0.5,5.5,1.4,8.2,2.2C349,269.8,349.6,268.2,348.6,267.8z"
            />
            <path
              className="st0"
              d="M348.8,271.7c-8.1-2.5-16.6-3.6-25-4c-0.7,0-0.8,1.1-0.1,1.1c8.4,0.5,16.5,2.3,24.6,4.5
  C349.3,273.5,349.9,272,348.8,271.7z"
            />
            <path
              className="st0"
              d="M349.5,275.7c-8.8-3.2-18.5-4.5-27.8-4.8c-0.5,0-0.6,0.8-0.1,0.8c9.5,0.6,18.4,2.7,27.4,5.4
  C349.9,277.3,350.3,276,349.5,275.7z"
            />
            <path
              className="st0"
              d="M352.5,280.9c-8.3-4.7-18.9-6.7-28.4-7.5c-1.1-0.1-1.2,1.6-0.1,1.7c0.6,0.2,1.2,0.5,1.9,0.7
  c0.2,0.2,0.6-0.1,0.6-0.3c8.8,1.5,16.7,4.4,25.2,7.1C352.6,282.8,353.4,281.4,352.5,280.9z"
            />
            <path
              className="st0"
              d="M354,285.9c-0.7-3.3-8.2-3.5-10.8-4.2c-6.2-1.6-12.5-3.3-18.8-4.6c-0.9-0.2-1.1,1.4-0.3,1.5
  c4.5,1.5,9.1,2.7,13.7,3.9c1.5,0.4,13.6,2.7,13.8,3.8C352,287.7,354.3,287.3,354,285.9z"
            />
            <path
              className="st0"
              d="M354.3,290.1c-9-2.7-18.4-5.3-27.8-6.2c-0.5-0.1-0.8,0.8-0.2,1c9.2,2.3,18.3,4.1,27.3,7
  C354.9,292.3,355.5,290.5,354.3,290.1z"
            />
            <path
              className="st0"
              d="M356.9,294.8c-9.6-3.3-19.9-5.4-29.9-6.5c-0.7-0.1-0.8,1-0.1,1.1c10,1.8,19.6,4.4,29.4,7.3
  C357.5,297.1,358.1,295.3,356.9,294.8z"
            />
            <path
              className="st0"
              d="M360.8,299.8C360.8,299.8,360.8,299.8,360.8,299.8c-11.2-3.6-23-6.8-34.7-8.6c-1-0.1-1.5,0.9-1.2,1.7
  c0.3,0.8,0.4,1,1.2,1.3c0.7,0.3,1.3,0.1,1.5-0.4c11.1,1.6,21.9,5,32.9,7.1C361.3,301.1,361.4,300.1,360.8,299.8z"
            />
            <path
              className="st0"
              d="M368.7,306.3c-12.3-3.6-24.8-6.7-37.3-9.6c-1.3-0.3-1.9,1.6-0.7,1.9c12.6,2.7,25.2,5.5,37.7,8.3
  C368.8,307,369.1,306.4,368.7,306.3z"
            />
            <path
              className="st0"
              d="M371.9,312.4c-7.6-2.7-15.5-4.7-23.2-6.9c-6.2-1.8-12.4-4-18.8-4.7c-1.4-0.2-1.6,2.1-0.2,2.2
  c14.3,1.1,28.1,7.1,42.2,9.8C372,312.8,372,312.5,371.9,312.4z"
            />
            <path
              className="st0"
              d="M375.7,316.5c-14.5-4.7-29.7-8.2-44.6-11.2c0.2,0.8,0.4,1.6,0.7,2.4c14.6,3.1,29.2,6.5,43.9,9.3
  C375.9,317,376,316.6,375.7,316.5z"
            />
            <path
              className="st0"
              d="M382,320.8c-15.5-3.8-31.2-7.1-47-9.4c-1.6-0.2-1.7,2.2-0.2,2.5c15.7,2.7,31.3,5.2,46.9,8.3
  C382.5,322.4,382.8,321,382,320.8z"
            />
            <path
              className="st0"
              d="M386,325.4c-14.6-2.8-29.4-5.1-44.1-7.6c-1.5-0.3-1.7,2.2-0.2,2.4c14.7,2.2,29.4,4.6,44.2,6.5
  C386.7,326.8,386.8,325.6,386,325.4z"
            />
            <path
              className="st0"
              d="M390.3,328.4c-14.8,0.9-29-3.6-43.6-5.3c-1.6-0.2-1.8,2.3-0.2,2.5c1.7,0.2,3.5,0.5,5.2,0.7c0.1,0,0.2,0,0.3,0
  c12.8,1.8,25.5,4.8,38.6,3.7C391.6,329.9,391.3,328.4,390.3,328.4z"
            />
            <path
              className="st0"
              d="M400.6,334.4c-15.7-1.7-31.2-4.9-46.9-6.5c-1.4-0.2-1.5,1.9-0.2,2.2c15.4,2.9,31.3,4.4,46.9,5.6
  C401.3,335.8,401.4,334.5,400.6,334.4z"
            />
            <path
              className="st0"
              d="M404.5,338.5c-17-1.6-33.9-3.4-50.8-5.2c-0.2-0.2-0.5-0.4-0.9-0.3l-1.6,0.1c-1.4,0.1-1.2,2.2,0.1,2.3
  c17.7,1.4,35.4,2.8,53.1,4.5C405.3,340,405.5,338.6,404.5,338.5z"
            />
            <path
              className="st0"
              d="M412.7,342c-18.5-1-37-2.3-55.5-4.4c-1.6-0.3-1.8,2.4-0.2,2.5c18.5,1.5,37.1,2.7,55.6,2.8
  C413.2,342.9,413.2,342,412.7,342z"
            />
            <path
              className="st0"
              d="M415.5,344.7c-18.5,1.1-37-1.5-55.4-2.6c-1.6-0.1-1.8,2.4-0.2,2.5c18.4,1.1,37.4,2.9,55.8,1.3
  C416.4,345.7,416.2,344.6,415.5,344.7z"
            />
            <path
              className="st0"
              d="M415.6,347c-16.8-0.4-33.9-0.8-50.7-0.6c-1.5,0-1.7,2.3-0.2,2.4c16.8,0.7,34.1,0.2,50.9-0.9
  C416.2,347.9,416.2,347,415.6,347z"
            />
            <path
              className="st0"
              d="M414.6,351.5c-13.5,1.8-27.1,0.9-40.6,1.5c1,0.7,1.9,1.5,2.8,2.3c12.7-0.5,25.7,0,38.1-2.7
  C414.7,352.2,414.6,351.9,414.6,351.5z"
            />
            <path
              className="st0"
              d="M412.7,355.9c-5.6,0.9-11.2,1.2-16.8,1.4c-3.7,0.2-9.7-0.7-12.8,1.5c-0.7,0.5-0.5,1.5,0.1,1.9
  c0.1,0,0.1,0.1,0.2,0.1c0.6,0.4,1.3,0.2,1.7-0.3c0,0,0,0,0.1-0.1c2.1-0.8,5.3-0.7,7.3-0.9c2.9-0.3,5.9-0.5,8.8-0.7
  c3.6-0.3,7.2-0.8,10.7-1.6C412.2,356.8,412.5,356.3,412.7,355.9z"
            />
            <path
              className="st0"
              d="M411,359.2c-4.2,0.6-8.4,0.9-12.7,0.9c-1.4,0-1.3,2.1,0.1,1.9c4.1-0.4,8.1-0.9,12.1-1.7
  C410.6,359.9,410.8,359.5,411,359.2z"
            />
            <path
              className="st0"
              d="M448.5,141c0.4-0.5-0.4-1.2-0.9-0.8c-0.5,0.6-1,1.1-1.6,1.7c-0.1,0.1,0,0.4,0.2,0.3c-4.7,2.4-9.5,7.9-14,11.3
  c-5.4,4-11,7.7-16.7,11.2c-10.6,6.6-21.4,12.8-31.8,19.7c-22,14.6-42.8,29.7-68.9,36c-1,0.2-0.7,1.7,0.3,1.5
  c25.4-3.4,46.6-19.5,67.3-33.3C404.7,173.5,430.7,161.8,448.5,141z"
            />
            <path
              className="st0"
              d="M458.9,145.3c-4.5-0.4-9.3-0.6-13.8-0.4c0-0.1-0.2-0.2-0.4-0.2c-0.5,0.1-1,0.1-1.5,0.2
  c-0.8,0-0.9,1.2-0.1,1.3c5.2,0.4,10.5,0.7,15.7,0.9C459.9,147.2,460,145.4,458.9,145.3z"
            />
            <path
              className="st0"
              d="M462.8,149.5c0.5-0.6,0.4-1.7-0.6-1.7c-8-0.2-16.1,0.1-24.1,0.3c-0.8,0-0.9,1.2-0.1,1.2
  c7.4,0,14.9,0.3,22.3,0.4c0.1,0.4,0.5,0.6,0.9,0.6C462.1,150.1,462.3,150.1,462.8,149.5z"
            />
            <path
              className="st0"
              d="M457.8,153.3c0-0.1,0-0.1,0.1-0.2c0.1-0.5-0.1-0.9-0.5-1.1c-1.4-0.7-3.3-0.3-4.8-0.3c-2.3,0-4.6,0-6.9,0
  c-4.2,0.1-8.4,0.3-12.6,0.6c-0.5,0-0.5,0.9,0,0.9c3.9-0.1,7.8-0.2,11.8-0.2c1.8,0,3.7,0.1,5.5,0.1c0.9,0,1.8,0.1,2.8,0.1
  c1.9,0.1,1.6-0.1,3.4-0.9c-0.8,0.4-0.4,1.6,0.5,1.5l0.2,0C457.5,153.8,457.7,153.5,457.8,153.3z"
            />
            <path
              className="st0"
              d="M452.8,154.9c-8.1-0.2-16.3,0.5-24.3,1.6c-0.6,0.1-0.4,1,0.2,1c8-0.8,15.9-0.9,24-0.8
  C453.8,156.7,454,155,452.8,154.9z"
            />
            <path
              className="st0"
              d="M445.9,158.4c-7.3,0.4-14.6,0.9-21.9,1.4c-0.8,0.1-0.6,1.3,0.2,1.2c6.8-0.4,13.6-0.7,20.4-0.9
  c0.1,0.1,0.3,0.2,0.6,0.1c0.3-0.1,0.7-0.1,1-0.2C447.3,159.8,447,158.4,445.9,158.4z"
            />
            <path
              className="st0"
              d="M441,162.4c-6.8,0.4-13.5,0.9-20.3,1.6c-0.7,0.1-0.5,1.1,0.2,1.1c6.3-0.5,12.5-0.8,18.8-0.9
  c0.1,0.1,0.3,0.2,0.6,0.1c0.3-0.1,0.7-0.1,1-0.2C442.3,163.8,442,162.3,441,162.4z"
            />
            <path
              className="st0"
              d="M434.1,166.9c-6.9,0.2-13.8,0.6-20.7,1.1c-0.7,0.1-0.5,1.1,0.2,1.1c6.8-0.3,13.6-0.5,20.4-0.6
  C435,168.5,435.1,166.9,434.1,166.9z"
            />
            <path
              className="st0"
              d="M428.8,171.7c-7.5,0-15,0-22.5,0c-0.8,0-0.9,1.2-0.1,1.3c7.5,0.1,15,0.2,22.5,0.3
  C429.7,173.3,429.8,171.7,428.8,171.7z"
            />
            <path
              className="st0"
              d="M422.9,175.8c-7.8-0.3-15.5-0.3-23.3,0c-0.7,0-0.8,1.2-0.1,1.1c7.8-0.2,15.5-0.1,23.3,0.4
  C423.7,177.4,423.9,175.8,422.9,175.8z"
            />
            <path
              className="st0"
              d="M414.5,180.8c-6.7-0.7-13.5-0.7-20.2-0.3c-0.6,0-0.4,1,0.2,0.9c6.7-0.4,13.3-0.2,19.9,0.6
  C415.2,182.1,415.3,180.8,414.5,180.8z"
            />
            <path
              className="st0"
              d="M411.1,184.2c-8.1-0.1-16.3,0-24.4,0.3c-0.8,0-0.9,1.3-0.1,1.3c8.1-0.2,16.3-0.2,24.4,0.1
  C412,185.9,412.1,184.2,411.1,184.2z"
            />
            <path
              className="st0"
              d="M404.2,188.4c-7.4-1.1-15.2-0.7-22.6,0.1c-0.6,0.1-0.4,1,0.2,1c7.5-0.7,14.8-0.3,22.3,0.2
  C404.9,189.7,405,188.5,404.2,188.4z"
            />
            <path
              className="st0"
              d="M398.2,193c-8.4-0.1-16.8,0.5-25.2,1c-0.6,0-0.6,1.2,0.1,1.1c8.3-0.4,16.7-0.4,25-0.7
  C398.9,194.3,399.1,193,398.2,193z"
            />
            <path
              className="st0"
              d="M391.7,196.2c-8.7,0.1-18,0.1-26.6,1.4c-0.5,0.1-0.5,0.9,0,0.9c8.7,0.7,17.9,0.1,26.6-0.5
  C392.9,198,392.8,196.2,391.7,196.2z"
            />
            <path
              className="st0"
              d="M388,199c-8.4,0.2-16.7,0.6-25,1.2c-0.2,0-0.2,0.4,0,0.4c8.3-0.3,16.6-0.4,24.9-0.2
  C388.9,200.4,389,199,388,199z"
            />
            <path
              className="st0"
              d="M385.7,201.9c-9.5-0.2-19,0.1-28.5,0.8c-0.5,0-0.4,0.8,0.1,0.8c9.4-0.6,18.8-0.6,28.2,0
  C386.6,203.6,386.7,201.9,385.7,201.9z"
            />
            <path
              className="st0"
              d="M381.2,205.5c-9-0.8-18.1-0.5-27,0.3c-0.5,0-0.3,0.7,0.1,0.7c9-0.5,17.8,0,26.8,0.6
  C382.1,207.1,382.2,205.6,381.2,205.5z"
            />
            <path
              className="st0"
              d="M376.1,209.1c-9.6-1.2-19.5-1.2-29.2-0.8c-0.8,0-0.9,1.3-0.1,1.2c9.8-0.3,19.4,0.4,29.2,1.2
  C377.1,210.9,377.2,209.2,376.1,209.1z"
            />
            <path
              className="st0"
              d="M370.8,212.5c-1.3-0.9-3.6-0.7-5.2-0.8c-2.7-0.2-5.5-0.4-8.2-0.5c-5.3-0.2-10.5,0-15.8,0.3
  c-0.6,0-0.6,1.1,0.1,1.1c4.7-0.2,9.4-0.3,14.2-0.1c2.2,0.1,4.5,0.2,6.7,0.4c2,0.2,5.1,0,7,0.7c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1
  c0.3,0.3,0.8,0.3,1.1,0.1c0,0,0.1-0.1,0.1-0.1C371.3,213.4,371.2,212.7,370.8,212.5z"
            />
            <path
              className="st0"
              d="M366.2,215.1c-11-0.8-22-1-33.1-0.9c-0.8,0-0.9,1.2-0.1,1.2c11,0,22,0.5,33,1.2
  C367.1,216.8,367.2,215.2,366.2,215.1z"
            />
            <path
              className="st0"
              d="M364.2,218.6c-12.7-1.4-25.4-1.7-38.2-1.1c-0.4,0-0.3,0.6,0,0.6c12.7-0.3,25.4,0.5,38,2.2
  C365.2,220.5,365.3,218.7,364.2,218.6z"
            />
            <path
              className="st0"
              d="M363.8,221.4c-14.3,0-28.6,0-42.8,1c-0.3,0-0.3,0.6,0,0.6c14.2,0.3,28.4,0,42.7,0.3
  C364.8,223.2,365,221.4,363.8,221.4z"
            />
            <path
              className="st0"
              d="M355.3,225c-7.4,0-14.8,0-22.3,0c-0.6,0-0.7,1-0.1,1c7.4,0.2,14.8,0.3,22.2,0.5
  C356.1,226.6,356.2,225,355.3,225z"
            />
            <path
              className="st0"
              d="M513.5,325c8.6-10,16.8-20.6,23.8-31.8c3-4.7,5.7-9.6,8.1-14.6c2-4.3,6.4-11.7,6-16.5c0,0.2,0.4,0.2,0.4,0
  c0.1-0.7,0.2-1.5,0.3-2.2c0.1-0.5-0.7-0.6-0.8-0.2c-7.9,24.2-23.5,44.8-39.9,63.9c-17.6,20.4-37.8,37.6-59.4,53.6
  c-1.1,0.9,0.3,2.4,1.4,1.7C475.8,364.1,496,345.3,513.5,325z"
            />
            <path
              className="st0"
              d="M554,270.3c-0.9-0.4-2.1-0.4-3.1-0.4c-0.8,0-2.1-0.2-2.7,0.3c-0.4,0.3-0.2,0.9,0.2,1.1
  c0.4,0.2,0.8,0.1,1.2,0.1c0.5,0,0.9,0.1,1.4,0.1c0.9,0.1,1.9,0.4,2.8,0.3C554.6,271.9,554.9,270.7,554,270.3z"
            />
            <path
              className="st0"
              d="M555.2,272.2c-2.5-0.1-5.1,0.3-7.7,0.4c-0.7,0-0.6,1.2,0.1,1.2c2.5,0,5.2,0.2,7.7-0.1
  C556.2,273.7,556.1,272.3,555.2,272.2z"
            />
            <path
              className="st0"
              d="M553.1,274.7c-2.6,0-5.2,0.2-7.8,0.6c-0.6,0.1-0.5,1.1,0.2,1c2.5-0.3,5-0.4,7.5-0.1
  C554,276.3,554.1,274.7,553.1,274.7z"
            />
            <path
              className="st0"
              d="M553,278c-3.2-0.7-6.5-0.7-9.7-0.2c-0.8,0.1-0.5,1.3,0.2,1.2c3.1-0.4,6.2-0.2,9.2,0.5
  C553.8,279.8,554.1,278.3,553,278z"
            />
            <path
              className="st0"
              d="M551.2,280.8c-3.1-0.5-6.5-0.3-9.6,0.2c-0.8,0.1-0.6,1.3,0.2,1.2c3.1-0.4,6.1-0.2,9.2,0
  C552,282.2,552.1,281,551.2,280.8z"
            />
            <path
              className="st0"
              d="M549.2,283.6c-2.7,0.1-5.3,0.3-8,0.4c-0.6,0-0.6,1.1,0.1,1.1c2.7-0.1,5.3-0.1,8-0.2
  C550.3,284.9,550.2,283.5,549.2,283.6z"
            />
            <path
              className="st0"
              d="M547.1,287.1c-2.6-0.8-5.5-0.5-8.1,0.1c-0.9,0.2-0.7,1.6,0.3,1.4c2.6-0.5,4.9-0.2,7.5,0.1
  C547.7,288.8,548,287.3,547.1,287.1z"
            />
            <path
              className="st0"
              d="M545.5,291c-3.1-0.5-6.4-0.2-9.5,0.6c-0.9,0.2-0.6,1.6,0.3,1.4c3-0.7,6-0.8,9.1-0.6
  C546.3,292.5,546.4,291.2,545.5,291z"
            />
            <path
              className="st0"
              d="M542.6,295.2c-2.9-0.5-5.8-0.4-8.7,0.2c-0.9,0.2-0.7,1.6,0.3,1.5c2.8-0.5,5.5-0.5,8.3-0.2
  C543.5,296.8,543.5,295.4,542.6,295.2z"
            />
            <path
              className="st0"
              d="M541.7,300.2c-3.8-0.1-7.6-0.1-11.5-0.2c-0.8,0-0.9,1.3-0.1,1.3c3.8,0.1,7.6,0.2,11.5,0.3
  C542.5,301.5,542.6,300.2,541.7,300.2z"
            />
            <path
              className="st0"
              d="M538.8,305.5c-3.9-0.9-8-1-12-0.7c-0.9,0.1-0.6,1.4,0.2,1.4c3.9-0.2,7.6,0.2,11.4,0.8
  C539.3,307.1,539.6,305.7,538.8,305.5z"
            />
            <path
              className="st0"
              d="M536.8,309.7c-4.4-0.4-8.9-0.1-13.3,0.2c-1,0.1-0.7,1.5,0.3,1.5c4.3-0.3,8.6-0.1,12.9-0.2
  C537.7,311.1,537.8,309.8,536.8,309.7z"
            />
            <path
              className="st0"
              d="M535.6,313.4c-4.7-1-10-0.5-14.8-0.3c-0.9,0-1,1.4-0.1,1.4c2.6-0.1,5.2-0.1,7.7-0.1c2.3,0,4.7,0.3,7.1,0.1
  C536,314.4,536.1,313.5,535.6,313.4z"
            />
            <path
              className="st0"
              d="M531.9,317.4c-3.8-0.1-7.5-0.3-11.3-0.4c-0.9,0-1.1,1.4-0.1,1.4c3.8,0.1,7.5,0.3,11.3,0.4
  C532.8,318.9,532.9,317.4,531.9,317.4z"
            />
            <path
              className="st0"
              d="M529.5,322.4c-5.2-0.8-10.9-0.1-16.1-0.1c-0.9,0-1,1.4-0.1,1.4c5.3,0,11,0.6,16.3-0.3
  C530.1,323.4,530,322.5,529.5,322.4z"
            />
            <path
              className="st0"
              d="M527.5,325.8c-2.2-1.2-5.3-0.5-7.7-0.3c-1.7,0.1-3.4,0.2-5.1,0.3c-1.4,0.1-2.9,0-4.2,0.5
  c-0.2,0.1-0.4,0.4-0.3,0.6c0,0.1,0,0.1,0.1,0.2c0.1,0.2,0.2,0.4,0.5,0.4c0.1,0,0.1,0,0.2,0c0.4,0.1,0.6-0.5,0.4-0.7
  c0.7,0.8,2.7,0.4,3.6,0.4c1.4,0,2.8-0.1,4.2-0.1c1.6,0,4.1-0.5,6.1-0.2c-0.1,0.5,0.3,1.1,1,0.9c0.4-0.1,0.8-0.2,1.2-0.3
  C527.8,327.2,528.2,326.2,527.5,325.8z"
            />
            <path
              className="st0"
              d="M524,329.2c-5.3,0.1-10.6,0.4-15.8,1.1c-0.5,0.1-0.3,0.8,0.1,0.7c5.2-0.5,10.4-0.7,15.6-0.5
  C524.7,330.5,524.8,329.2,524,329.2z"
            />
            <path
              className="st0"
              d="M520.2,334.1c-6.1-0.2-12.1,0-18.2,0.7c-0.7,0.1-0.5,1.1,0.2,1.1c5.6-0.5,11.1-0.5,16.7-0.2
  c0.2,0.3,0.5,0.4,0.9,0.3c0.2-0.1,0.4-0.2,0.7-0.3C521.2,335.3,521,334.1,520.2,334.1z"
            />
            <path
              className="st0"
              d="M519.6,338.2c-6.9,0-13.8,0.5-20.6,1.2c-0.7,0.1-0.5,1.2,0.2,1.1c6.8-0.5,13.5-0.6,20.3-0.7
  C520.5,339.8,520.7,338.2,519.6,338.2z"
            />
            <path
              className="st0"
              d="M515,342c-6.9-0.1-13.9,0.5-20.8,1.2c-0.8,0.1-0.5,1.2,0.2,1.2c6.8-0.5,13.6-0.6,20.5-0.7
  C515.9,343.6,516.1,342,515,342z"
            />
            <path
              className="st0"
              d="M511.7,345.9c-7.8,0.3-15.6,0.8-23.4,0.9c-0.7,0-0.8,1.1-0.1,1.1c7.8,0,15.7,0.1,23.5-0.5
  C512.6,347.4,512.6,345.8,511.7,345.9z"
            />
            <path
              className="st0"
              d="M508.5,351.7c-8.4-0.2-16.9-0.4-25.3-0.6c-0.8,0-0.9,1.2-0.1,1.3c8.4,0.3,16.8,0.6,25.3,1
  C509.4,353.4,509.5,351.7,508.5,351.7z"
            />
            <path
              className="st0"
              d="M503.6,356.3c-8.1-0.4-16.1-0.1-24.2,0.6c-0.7,0.1-0.5,1,0.2,1c7.6-0.5,15.3-0.5,22.9-0.1c0.1,0,0.1,0,0.2,0
  c0.2,0,0.5,0,0.7,0C504.4,357.9,504.6,356.4,503.6,356.3z"
            />
            <path
              className="st0"
              d="M500.1,360.9c-8.9,0.5-17.8,0.3-26.7-0.6c-0.9-0.1-1,1.4-0.1,1.4c8.9,0.9,17.9,1.2,26.9,0.8
  C501.4,362.5,501.3,360.8,500.1,360.9z"
            />
            <path
              className="st0"
              d="M495.9,364.5c-9.4-0.2-18.7-0.2-28.1,0.1c-0.7,0-0.8,1.1-0.1,1.1c9.4-0.2,18.7,0,28,0.4
  C496.7,366.1,496.9,364.5,495.9,364.5z"
            />
            <path
              className="st0"
              d="M490.4,369.4c-9.8-1.2-19.8-1.1-29.6-0.3c-0.7,0.1-0.5,1.1,0.2,1.1c9.8-0.6,19.5-0.1,29.3,0.8
  C491.2,371,491.3,369.5,490.4,369.4z"
            />
            <path
              className="st0"
              d="M485.9,373c-10.3-0.1-20.6,0-31,0.4c-0.8,0-0.9,1.3-0.1,1.3c10.3-0.3,20.6-0.3,30.9,0
  C486.9,374.7,487,373,485.9,373z"
            />
            <path
              className="st0"
              d="M486.5,375.6c-12,0.1-24,0.8-36,1.2c-1,0-1.1,1.6-0.1,1.5c12-0.4,24.1-0.4,36.2-1.2
  C487.5,377.1,487.4,375.6,486.5,375.6z"
            />
            <path
              className="st0"
              d="M483,378.1c-10.6,0.1-21.2,0.6-31.8,1c-1,0-1.2,1.6-0.1,1.6c10.7-0.3,21.4-0.5,32-1.1
  C483.9,379.6,483.8,378.1,483,378.1z"
            />
            <path
              className="st0"
              d="M482.5,380.5c-9.9,0.2-19.7,1-29.6,1c-1.1,0-1.2,1.7-0.1,1.7c9.9,0,20,0.1,29.8-1.1
  C483.4,382,483.4,380.5,482.5,380.5z"
            />
            <path
              className="st0"
              d="M476.4,384.2c-6.9,0.1-13.9,0.6-20.8,1c-0.9,0-0.8,1.5,0.1,1.5c6.9-0.3,13.9-0.4,20.8-0.9
  C477.4,385.7,477.3,384.2,476.4,384.2z"
            />
            <path
              className="st0"
              d="M473.6,387.8c-6.9,0-13.9,0.4-20.8,0.8c-1.1,0.1-0.8,1.7,0.3,1.6c6.8-0.4,13.6-0.5,20.4-0.8
  C474.5,389.3,474.7,387.8,473.6,387.8z"
            />
            <path
              className="st0"
              d="M469.2,391.6c-5-0.1-10.2,0.4-15.2,0.6c-1,0-1.1,1.6-0.1,1.6c5.1-0.2,10.3-0.1,15.4-0.6
  C470.1,393,470.1,391.6,469.2,391.6z"
            />
            <path
              className="st0"
              d="M464,395c-2.3,0.4-4.6,0.8-6.9,1.3c-0.6,0.1-0.4,1,0.2,0.9c2.3-0.4,4.6-0.8,7-1.1
  C464.9,395.9,464.7,394.9,464,395z"
            />
            <path
              className="st0"
              d="M196.1,507.9c8.9-11.8,18.7-22.8,29.3-33.1c1.5-1.5-0.6-4-2.1-2.5c-8.9,8.4-17.2,17.4-24.8,26.9
  c10.3-37.3,31-70.9,59.9-96.8c1.1-1,0.6-2.4-0.6-3c-10.8-5.2-26.4-2.2-37.7,0.1c-10.4,2.1-20.5,5.5-30,10
  c12.2-13.9,24.6-27.5,38.9-39.2c16.6-13.6,35.6-23.4,54.6-33c1.2-0.6,1.3-2.7-0.2-3.1c-14.9-3.6-30.1-5.2-45.4-4.7
  c19.4-12,40.6-20.3,63.1-24.8c1.6-0.3,1.6-2.4,0.2-3c-8.2-3.7-16.4-7.4-24.6-11.1c11.9-2.1,24-3.2,36.1-3.3c1.7,0,2.7-2.2,1.1-3.2
  c-2.3-1.6-4.5-3.1-6.8-4.7c6.9,1,13.2,4.3,18.6,9c0.8,0.7,1.9-0.6,1.3-1.4c-6.3-8.3-15.9-12-26.2-11.6c-1.8,0.1-2.9,2.3-1.2,3.4
  c2.6,1.7,5.1,3.5,7.7,5.2c-12.2,0.5-24.2,2-36.2,4.5c-1.6,0.3-1.6,2.4-0.2,3c8.3,3.7,16.5,7.4,24.7,11.2
  c-23.1,5.2-44.9,14.5-64.8,27.5c-1.5,1,0,2.9,1.3,2.8c15.4-1,30.6,0.2,45.7,3.4c-17.9,9.1-35.6,18.7-51.2,31.4
  c-16.8,13.7-31.2,30.1-45.4,46.4c-1.1,1.3,0.7,3.3,2.2,2.6c11-6,22.6-10.6,34.9-13.3c10.5-2.3,24.8-5.4,35.5-1.8
  c-30.3,27.9-51.7,64.4-61.1,104.6C192.5,508.3,194.8,509.6,196.1,507.9z"
            />
            <path
              className="st0"
              d="M323.3,464.4c9.6-12.1,19.5-24.2,27.4-37.5c4.9-8.2,7.6-16.4,9.2-25.3c1.2,8,1.6,16,1.3,24.1
  c-0.1,1.5,1.8,2.7,3,1.5c12.3-12.1,20.7-27,24.6-43.6c1.5,2.5,3.1,5.1,4.6,7.6c0.8,1.3,2.8,1.5,3.3-0.2c1.3-4,2.1-8,2.2-12.2
  c0-3.6-2.8-10.7-1.2-13.5c0.9-1.6-1.4-3.2-2.4-1.6c-1.8,2.8-0.7,5.2-0.2,8.3c0.7,4.7,0.4,9.4-0.7,13.9c-1.6-2.7-3.2-5.4-4.8-8.1
  c-1-1.6-3.2-1.2-3.5,0.6c-2.9,16.1-10.2,30.7-21.2,42.7c0.1-10.5-1.1-20.8-3.6-31.1c-0.5-2-3.4-1.9-3.6,0.2
  c-1.4,14.3-4.7,26.2-12.5,38.4c-6.4,9.9-13.6,19.3-20.9,28.6c1.4-14.4,0.2-28.7-3.5-42.8c-0.5-2-3.2-1.9-3.5,0.2
  c-3.8,22.8-18.5,41-33.5,57.8c1.4-14.8,1.1-29.6-1-44.4c-0.2-1.1-1.5-1.8-2.5-1.3c-12.4,6.3-23.1,15.1-33.5,24.2
  c-11.2,9.8-22.2,19.7-33.2,29.7c-1.2,1.1,0.4,3,1.6,1.9c10.7-9,21.3-18.1,31.9-27.3c10.2-9,20.5-17.8,32.6-24.3
  c1.9,15.5,1.9,30.9,0,46.4c-0.2,1.4,1.9,2.6,2.9,1.5c15-16.7,30.3-34.3,36.4-56.1c2.6,13.3,2.9,26.8,0.9,40.3
  C319.7,465.2,322.3,465.7,323.3,464.4z"
            />
            <path
              className="st0"
              d="M368.5,368.7c2.3-4.4,4.6-8.8,6.7-13.3c0.8-1.6-1.9-2.9-2.8-1.4c-2.5,4.2-4.7,11.3-8.1,14.7
  c-0.3,2.3-1.1,2.7-2.4,1.2c-1.3-0.6-2.2-1.7-2.6-3.2c-2-2.8-3.5-6.2-5.2-9.2c-0.7-1.2-2.4-1.5-3.2-0.3c-2.7,4.1-4.9,8.3-6.2,13
  c-1.3,4.6-1.5,10.4-4.8,14.1c-0.5-5.2-0.9-10.3-1.5-15.5c-0.4-3.6-0.8-6.2-3.7-8.6c-0.8-0.7-2-0.2-2.6,0.5
  c-4.9,6-9.7,12.1-14.3,18.3c-3.7,4.9-7,10.9-11.8,15c2.3-6.2,4.5-12.5,6.5-18.9c0.5-1.6-1.1-3-2.6-2.3c-9,3.8-17.8,7.8-26.7,11.9
  c12.3-11.7,25.6-22.2,40-31.3c1.4-0.9,1.5-2.9-0.2-3.6c-6.8-2.7-13.7-4.4-20.8-5.1c11-4.3,22.2-7.7,33.7-10.2
  c1.6-0.4,2-2.4,0.7-3.4c-7.9-6-16.2-11.3-25.1-15.7c7.7-1.5,15.1-1.3,23.1-0.7c0.7,0.1,1.2-0.7,0.9-1.3c-0.9-2-1.8-4.1-2.7-6.1
  c0,0-0.1,0-0.1,0c0.3,1.7,1.3,4.1-0.2,4.9c-1.2,0.7-8.4-1.1-9.9-1.1c-5.7-0.1-11.3,0.6-16.8,2c-1.8,0.5-1.8,2.6-0.3,3.4
  c9,4.4,17.5,9.4,25.5,15.3c-13.3,3.1-26.2,7.3-38.8,12.7c-1.7,0.7-1.3,3.7,0.7,3.7c8.6-0.1,16.8,1.2,24.9,3.9
  c-16.4,10.8-31.6,23.2-45.2,37.4c-1.4,1.5,0,4.2,2,3.2c10.8-5.1,21.7-10.1,32.6-14.8c-2.2,6.8-4.6,13.5-7.2,20.2
  c-0.6,1.5,1.1,3,2.6,2.3c6.8-3.1,10.5-9.3,14.8-15.2c5.1-7,10.4-13.8,15.9-20.6c1.7,3,1.3,8.2,1.6,11c0.4,4.2,0.8,8.4,1.2,12.5
  c0.1,1.1,1.6,1.9,2.6,1.4c4-2.3,5.9-5.7,7.1-10.1c1.8-6.2,3.1-11.9,6.1-17.5c2,3.8,3.9,8,6.5,11.2c1.1,1.4,2.1,2.6,4,2.4
  C365.9,375.3,367.3,370.9,368.5,368.7z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M396,421.3c-11.6-5.8-22.8,8.4-23.3,19c-0.6,14.3,16.1,17.2,21.5,27.8c3.5,6.9-0.9,14.4-8.9,12.8
  c-7.3-1.5-9.4-8.3-10.8-14.7c-1-4.4-8.1-3.5-7.9,1.1c0.3,11.1,9.5,22.7,21.5,21c10.3-1.5,15.6-12.5,12-21.9
  c-2.1-5.4-6.7-9.2-10.9-13c-4.4-4-9.3-8.9-7.5-15.4c1.5-5.5,7.9-13.2,13.4-7.4c4.8,5,5.5,13.5,4.8,20c-0.1,1.2,1.6,1.5,2.2,0.6
  C407.9,442.1,406.6,426.5,396,421.3z"
            />
            <path
              className="st0"
              d="M425.1,426.4C425.1,426.4,425.1,426.4,425.1,426.4c0-0.2,0-0.4-0.1-0.5l-0.1,0.1c-0.6-1.5-2.8-2.5-3.9-0.6
  c-3.8,7.1-4,17.1-5.1,25c-1.2,8.9-2.1,17.8-2.8,26.7c-0.4,5.2,7.9,5.3,8.1,0c0.3-8.8,0.9-17.5,1.7-26.3
  C423.8,443,426.1,434.2,425.1,426.4z"
            />
            <path
              className="st0"
              d="M437.3,420.2c-4.8,0.6-9.6,1.3-14.4,1.9c-4.7,0.7-9.8,0.9-14.3,2.3c-3.1,0.2-3.8,5.8,0.4,6.2
  c4.7,0.4,9.5-0.4,14.2-0.8c4.7-0.4,9.5-0.9,14.2-1.3C442.6,428,442.5,419.5,437.3,420.2z"
            />
            <path
              className="st0"
              d="M458.5,450.5c0-9.9,0-19.8,0-29.6c0-4.8-6.7-5.4-8.1-1.1c-3.3,9.6-7.5,18.8-11.6,28.1
  c-3.8,8.7-7.3,17.3-7.6,26.9c0,1.4,2.2,2.1,2.8,0.8c4.1-8.9,8-17.9,12.4-26.7c1.4-2.8,2.8-5.6,4.2-8.4c0.1,3.4,0.1,6.7,0.2,10.1
  c0.2,9.4-0.6,19.5,1.5,28.6c0.6,2.7,4.9,2.7,5.4,0C459.5,470,458.5,459.9,458.5,450.5z"
            />
            <path
              className="st0"
              d="M452.7,449.3c-4.9,0.8-10,3.5-14.1,6.3c-3.1,2-0.4,6.2,2.8,4.8c4.3-1.9,8.8-2.6,13.3-3.8
  C459.5,455.4,457.4,448.5,452.7,449.3z"
            />
            <path
              className="st0"
              d="M473.7,417.7c-0.6-1.1-1.9-0.8-2.5,0l0,0c-2.4,3.2-2.2,8.3-2.7,12.2c-0.6,5.3-1,10.6-1.4,15.9
  c-0.7,10.2-1.5,20.6-1.4,30.9c0.1,5.2,7.8,5.1,8,0c0.5-10.3,0.4-20.6,0.6-30.9c0.1-5,0.3-10,0.4-15
  C474.8,426.5,475.8,421.5,473.7,417.7z"
            />
            <path
              className="st0"
              d="M472,434c-1,0-1,1.6,0,1.6C473,435.6,473,434,472,434z"
            />
            <path
              className="st0"
              d="M493.5,468.2c-2.7-3.8-5.8-7.3-8.3-11.2c-1.1-1.7-2.2-3.5-3.2-5.3c-0.8-1.3-3.1-4.4-3.2-5.8
  c-0.3-2.1,6.5-8.1,8.2-10.2c2.6-3.2,4.9-6.5,5.5-10.7c1.1-7.4-4.1-13.6-11.7-13.8c-7.3-0.2-13.5,5.3-16.6,11.6
  c-1.6,3.4,2,4,3.7,2.8c0,0,0,0.1,0,0.1c2.5-2.1,4.6-4.5,7.5-6c2.5-1.3,7.1-1.9,8.7,1.2c1.9,3.8-2.3,8.1-4.6,10.6
  c-2.4,2.7-4.9,5.3-7.2,8.1c-4.6,5.5-0.8,11.1,2.2,16.5c3.4,6,7.4,12.4,12.4,17.2C490.2,476.4,496.4,472.1,493.5,468.2z"
            />
            <path
              className="st0"
              d="M512.4,418c-2.8,7.8-3.2,17.2-4,25.4c-0.9,8.8-1.4,17.7-1.7,26.5c-0.2,5.3,8.2,5.3,8.2,0
  c0.1-8.6,0.4-17.1,1.1-25.7c0.6-8.1,2.3-16.6,2.2-24.8C518.6,416.9,513.9,413.7,512.4,418z"
            />
            <path
              className="st0"
              d="M526.7,411.9c-8.1,0.2-16.6,0.6-24.6,1.8c-3.9,0.6-2.6,6.2,0.9,6.5c7.7,0.6,15.9,0.4,23.7,0
  C532,419.9,532.1,411.8,526.7,411.9z"
            />
            <path
              className="st0"
              d="M576.7,418.2c-0.4-5.4-7.5-5.2-8.2,0c-1.1,8.2-0.7,16.4-2.2,24.5c-1.3,6.9-3.4,16.3-8.6,21.5
  c-0.6,0.4-0.6,0.7-0.1,1.1c-0.8-0.6-1.4-1.4-1.8-2.3c-0.9-1.8-1-4.1-1.2-6c-0.3-4.7-0.3-9.4-0.2-14.1c0.2-9.6,1.5-19.2,1.5-28.9
  c0,0,0,0-0.1,0c0-2.6-4.2-4.1-5.3-0.7c-3.9,12.2-4.4,25.9-4.5,38.7c0,7.4,0.7,23.3,11.9,22.1c9-0.9,13.6-16,15.5-23.2
  C576.2,440.7,577.5,428.8,576.7,418.2z"
            />
            <path
              className="st0"
              d="M592.9,415.2C592.9,415.2,592.9,415.2,592.9,415.2c0-0.1-0.1-0.3-0.1-0.4c0,0,0,0,0,0c-0.7-1.8-3.7-3-4.9,0
  c-1.5,3.7-1.4,8-1.7,11.9c-0.3,4.7-0.6,9.4-0.8,14c-0.5,8.7-2.2,18.4-1.3,27.1c0.4,4.1,7,5.9,7.9,1.1c1.7-8.7,0.9-18.4,1.2-27.2
  c0.1-4.4,0.2-8.7,0.4-13.1C593.5,424.2,594.1,419.4,592.9,415.2z"
            />
            <path
              className="st0"
              d="M612.5,413.6c-3.7-5.1-10.1-7.4-16.1-5.4c-5.6,1.9-10.5,7.7-9.8,13.8c0.2,1.6,2.4,2.6,3.3,0.9
  c1.8-3.6,4-7.2,8.3-8.1c3.4-0.7,6.8,1.1,8.3,4.2c4.2,8.8-9.2,11.5-14.7,12.6c-4.9,0.9-3.8,9.4,1.2,8.8c7.4-0.9,15.3-3.2,19.7-9.6
  C616.4,425.5,616.4,418.8,612.5,413.6z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M215,79.1c-1-3.6-4.1-6.1-7.4-7.6c-4.7-2.1-19.7-0.1-20.3-6.5c-0.2-2.4,3.3-7.3,4.6-9.3
  c1.9-3,4.1-5.8,6.6-8.3c3.7-3.7,10.1-7.5,13.6-1.3c2.4,4.2,1.2,9.2-1.7,12.7c-0.4,0.4,0.2,1,0.6,0.6c5.3-5.2,5.6-18.3-3.9-19.1
  c-4.9-0.4-9.1,3.9-12.1,7.1c-4.1,4.5-7.7,9.8-9.8,15.5c-1.3,3.6-0.8,6.7,3,8.3c6.9,3,15.4-0.6,21.6,4.9c9.2,8.2-5.1,16.1-11.9,18
  c-6.9,1.9-17.1,2.5-20.5-5.3c-0.6-1.4-2.9-0.4-2.4,1c2.9,9,14.5,9.2,22.1,7.4C204.8,95.5,217.9,89.2,215,79.1z"
            />
            <path
              className="st0"
              d="M229,83.6c-1.2,1.2-4.7,2-6.1,0.7c-0.7-0.7-0.5-3.4-0.5-4.3c0-3,0.6-6.1,1.3-9c0.9-3.9,2.1-7.6,3.2-11.4
  c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.6,0.3-1.1,0.4-1.7c0.2-0.6,0.3-1.1,0.5-1.7c0.3-1-1.3-1.4-1.6-0.4c-3.2,8.2-8,19.4-6.2,28.4
  c1.3,6.7,6.7,6,10.6,1.6C231.9,84.2,230.2,82.5,229,83.6z"
            />
            <path
              className="st0"
              d="M229.9,66.3c-5-1.8-9.6,2-14.4,2.6c-1.3-0.1-1.3,1.9,0,2c4.7,0.2,9.1-3.9,13.7-2.1
  C230.8,69.4,231.5,66.8,229.9,66.3z"
            />
            <path
              className="st0"
              d="M248.5,69.3c-4.5-3.6-7.8-1.4-10,2.6c-0.1-1.2-0.3-2.3-0.5-3.5c-0.2-0.8-1.3-0.5-1.3,0.2c0,0,0,0,0,0
  c0.2,2.8,0.1,5.6-0.3,8.3c-1.1,3.5-1.7,7.1-1.8,9.2c-0.1,1.3,2.1,1.6,2.3,0.3c0.3-2,0.7-4,1-6.1c1.2-5.7,3.7-12,9.1-9.2
  C248.2,71.9,249.6,70.2,248.5,69.3z"
            />
            <path
              className="st0"
              d="M264.6,80.2c-1,0.9-2.3,2.5-3.6,2.9c-2.9,0.8-2.3-1.8-2-3.7c0.4-2,1-4,1.2-6.1c0,0,0,0,0,0c0,0,0,0,0,0
  c0-0.1,0-0.2,0-0.4c0-0.3,0-0.5-0.1-0.6c-0.2-1.6-1.2-2.9-3.1-3.1c-2.1-0.2-4,1.5-5.3,2.9c-2.9,3.1-7.2,9-5.5,13.5
  c1.8,5,6.2,0.4,9.6-4.6c-0.1,1.4,0.1,2.7,0.8,3.8c2.7,3.9,7.8-0.3,9.9-2.6C267.8,80.9,265.9,79,264.6,80.2z M249.3,85.2
  c-3,0.6-0.1-6.2,0.4-7.3c0.9-1.7,1.9-3.4,3.1-4.8c1.1-1.3,6-5.5,6.7-1.4c-0.7-0.2-1.6,0.1-1.8,0.8c-0.7,2.2-2,4.3-3.2,6.2
  C253.6,80.3,251.4,84.8,249.3,85.2z"
            />
            <path
              className="st0"
              d="M278.8,78.8c-1.3,2.2-3.7,5.8-5.6,1.8c-1.2-2.6-0.2-7,0.4-9.6c0.6-2.8,1.5-5.6,2.1-8.4c0.1,0,0.1-0.1,0.1-0.2
  l0.5-0.7c0.2-0.2,0-0.5-0.3-0.6c0,0,0,0,0,0c0.3-1.3,0.5-2.6,0.6-3.9h0c0-1.1-1.8-1.5-2-0.3c-1.3,7.5-7.5,18.7-3.3,26.2
  c2.9,5.2,8,0.7,9.8-2.9C281.9,78.7,279.6,77.3,278.8,78.8z"
            />
            <path
              className="st0"
              d="M279.6,67.5c-4.5-0.1-8.8,1.2-13,2.7c-1.9,0.7-0.1,2.7,0.9,2c4-1,7.9-2.2,12.1-2
  C281.3,70.3,281.3,67.5,279.6,67.5z"
            />
            <path
              className="st0"
              d="M297.6,78.5c-2.7,1.1-9.2,5.3-11.1,0.8c-0.3-0.8-0.4-1.8-0.3-2.9c3.1,0.2,5.9-3.2,6.9-6
  c0.6-1.5,0.9-3.5-0.4-4.8c-1.3-1.2-3.3-0.8-4.5,0.1c-2.2,1.7-3.8,5.4-4.4,8.9c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.2,0,0.2
  c-0.2,1.6-0.2,3.2,0.1,4.5c1.8,7.2,10.6,3.5,14.8,1.3C299.9,80.3,299,77.9,297.6,78.5z M288,70.3c0.4-0.8,1.4-3.1,2.6-2.9
  c1.2,0.2,0.7,1.7,0.4,2.6c-0.4,1.3-1.2,2.7-2.2,3.7c-0.1,0.1-1.4,0.9-2.4,1.3C286.8,73.2,287.4,71.5,288,70.3z"
            />
            <path
              className="st0"
              d="M313.9,67.6c-0.1-1-1.1-1.5-1.9-1.2c-0.3-0.1-0.6-0.2-1-0.2c-3.5-0.1-7.5,4.7-8.8,7.5c-1.2,2.6-1.2,8,2.7,8.1
  c3.2,0.1,5.3-2.9,6.6-6.2c0.2,5.6,0,11.2-1.7,16.4c-2.7,8-11.6,13.7-18.3,6.3c-1.2-1.4-3.2,0.6-2,2c5.8,6.9,14.4,5.3,19.8-1.4
  C316.1,90.4,314.5,77.6,313.9,67.6z M308.1,76.5c-0.9,1.3-3.5,4.9-4.4,0.4c-0.2-1,0.6-2.5,1-3.3c0.8-1.4,4.6-5.3,6.3-5.5
  C310.3,71,309.9,74,308.1,76.5z"
            />
            <path
              className="st0"
              d="M332.1,65.8c-0.1-1.4-1.8-1.9-2.6-0.7c-1.9,2.7-2.7,8.1-5.6,10c-4.4,2.8-2.8-6.7-3.1-9.1c0,0,0,0,0,0
  c0-1-1.6-1.3-1.7-0.2c-0.5,3.5-2.5,11.7,2.6,12.8c2.6,0.6,4.5-1.2,6-3.7c-0.6,1.8-1.1,3.5-1.4,5.3c-0.9,5-1.7,9.9-3.7,14.6
  c-0.6,1.5,1.9,2.5,2.6,1.1c2.3-5,3-10.4,4-15.7C330.1,75.4,332.6,70.7,332.1,65.8z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M73.2,178.5c-0.1-0.9-1.6-1.3-1.8-0.2c-0.1,0.7-0.2,1.4-0.3,2.2c-0.8,6.9-1.6,13.8-2.9,20.7
  c-1.2,6.5-2.4,13.1-2,19.7c0.1,1.7,2.6,1.7,2.6,0c0.2-7.7,1.2-15.1,2.5-22.7C72.6,191.7,74,185,73.2,178.5z"
            />
            <path
              className="st0"
              d="M100,173.5c-2.6-2.2-5.2-1.8-8.4-1.1c-6.3,1.2-12.2,3.5-18.1,5.8c-4.1,1.6-8.2,3.3-12.2,5
  c-2.2,0.9-4.5,1.9-6.8,2.5c-1.8,0.5-3.9,0.5-5.6,1.2c-0.6,0.2-0.7,0.9-0.2,1.3c4.5,3,14.1-2.9,18.4-4.7c4.6-1.9,9.3-3.6,14-5.3
  c3.7-1.3,13.6-5.6,17-2.6C99.3,176.7,101.3,174.7,100,173.5z"
            />
            <path
              className="st0"
              d="M98.7,211.9c-1.7,1.5-6.5,5.4-7.9,1.5c-0.7-1.9,1.2-5.5,1.7-7.4c0.1-0.4,0-0.8-0.2-1.1c0.3,0,0.5-0.2,0.4-0.5
  c-0.8-3.3-4.3-2.8-6.6-1.4c-3.8,2.2-7.2,6.4-8.6,10.6c-0.9,2.9-0.4,8.6,3.9,7.3c2.9-0.9,5-3.3,6.6-6c0.2,1,0.7,1.9,1.6,2.6
  c3.3,2.4,8.6-1.2,10.9-3.6C101.8,212.5,100,210.8,98.7,211.9z M83.9,215.8c-1,1.1-2.9,3.3-3.9,2.3c-0.9-0.9-0.4-3-0.2-4
  c0.8-3,8.1-14,11.9-9.8c-0.6-0.2-1.3-0.1-1.7,0.6C88.1,208.6,86.6,212.7,83.9,215.8z"
            />
            <path
              className="st0"
              d="M116,200.5c-4.2-0.5-7.2,1.7-9,4.9c-0.1,0-0.1-0.1-0.2-0.1c-0.2-1.3-0.7-2.5-1.4-3.6
  c-0.5-0.7-1.6-0.3-1.4,0.6c0.2,0.9,0.5,1.8,0.9,2.5c0.4,2,0.3,4.3,0.1,6.5c-0.2,1.5-0.3,3-0.2,4.4c0.1,1.5,2.4,1.5,2.3,0
  c-0.3-5.4,2.1-13.4,8.8-12.5C117.7,203.4,117.7,200.7,116,200.5z"
            />
            <path
              className="st0"
              d="M127.6,204.4c0.1-0.7-0.3-1.3-0.9-1.5c0,0,0-0.1,0-0.1c-1.9-6.7-10.9,4.6-11.2,7.8c-0.3,2.7,1.5,4.8,4.2,3.8
  c1.9-0.7,3.6-2.6,5-4.7c0.2,5.8,1.8,11.5,0.4,17.3c-1.1,4.3-3.2,7.3-8.1,7c-3.6-0.2-8-1.5-10.1-4.6c-1.1-1.5-3.5-0.1-2.5,1.4
  c3.7,5.2,14.3,8.6,19.7,4C132.6,227.6,126.1,213.4,127.6,204.4z M117.4,211.6c-1.2-1.4,2-5.7,2.8-6.6c0.9-1.1,4.7-5.2,5.7-2.2
  c-0.2,0.1-0.5,0.3-0.6,0.6C124.5,205.1,119.8,214.4,117.4,211.6z"
            />
            <path
              className="st0"
              d="M141.6,209.8c-2.3,0-8,3.2-9.4,0.4c-0.2-0.4-0.3-1-0.2-1.7c3.3-0.3,6.3-3.5,6.7-6.8c0-0.4-0.2-0.8-0.6-1
  c-4.5-2.3-9.2,4.9-8.9,8.8c0.5,6.9,8.7,3.7,12.7,2.8C143.5,212.1,143.1,209.8,141.6,209.8z M136.3,202.8c-0.5,1.7-2,3.2-3.7,3.9
  C133.4,204.8,134.8,203,136.3,202.8z"
            />
            <path
              className="st0"
              d="M154,206.9c-5.8,6.3-5.3-7.2-5-9.7c0.7-4.7,1.9-9.3,2.6-14c0.2-1-1.4-1.5-1.6-0.4c-2,7.2-6,17.1-3.3,24.6
  c1.8,5,5.9,5.4,9.2,1.4C157,207.5,155.2,205.6,154,206.9z"
            />
            <path
              className="st0"
              d="M155.3,191.3c-4.7-0.9-9.5,1.5-13.9,2.7c-1.3,0.4-0.3,2,0.5,1.7c4.5-0.2,8.4-2.4,13.1-1.9
  C156.4,193.9,156.7,191.5,155.3,191.3z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M79.4,338.2c-3.3,7.5-6.2,15.2-8.4,23.1c-1.5,5.3-2.2,10.9-3.4,16.3c-0.6-11.9-2-23.7-5.1-35.2c0,0,0,0,0,0
  c-0.4-1.3-2.6-1-2.3,0.6c3.1,14.1,4.6,28.4,4.7,42.8c0,1.3,2.1,2.1,2.7,0.7c3.1-6.9,3.6-14.5,5.5-21.8c2.2-8.8,5.6-17.1,8.9-25.5
  C82.6,337.8,80,336.8,79.4,338.2z"
            />
            <path
              className="st0"
              d="M86.8,361.6c-0.1-1.6-2.3-1.4-2.3,0c0,0,0,0,0,0c-0.4,6.4-0.3,12.6-1.5,18.9c-0.3,1.8,2.3,2.5,2.7,0.7
  C86.9,375,87.3,368.1,86.8,361.6z"
            />
            <path
              className="st0"
              d="M86.5,353.1c-0.4-0.2-0.8-0.1-1.1,0.1c-0.6,0.4-0.8,1.3-0.2,1.8c0.5,0.5,1.5,0.4,1.8-0.2
  C87.3,354.3,87.2,353.4,86.5,353.1z"
            />
            <path
              className="st0"
              d="M100.6,368.5c-0.8-0.3-1.6-0.5-2.5-0.5c-0.3,0-1.8,0.2-1.9,0c-0.4-0.5,0.7-3,0.9-3.3c0.6-1,1.4-2.3,2.6-2.7
  c0,0.4-0.1,0.9-0.1,1.3c-0.1,0.8,1.1,0.8,1.4,0.2c0.3-0.8,0.4-1.7,0.6-2.5c0-0.4-0.3-0.8-0.6-0.8c-4.1-0.9-10.2,7.9-5.8,10.2
  c1.7,0.9,7-0.3,7,3c0,2.2-3.9,3.8-5.2,2c-0.9-1.1-3.1-0.5-2.5,1.1c1.8,5.2,9.6,1.9,10.4-2.3C105.2,371.3,103,369.3,100.6,368.5z"
            />
            <path
              className="st0"
              d="M108.7,359.5L108.7,359.5c-0.2-0.7-1.3-0.8-1.5,0c-0.4,1.6-0.1,3.6-0.2,5.2c-0.1,2.2-0.3,4.4-0.3,6.6
  c0,1.6,2.6,1.6,2.6,0C109.1,367.4,109.7,363.3,108.7,359.5z"
            />
            <path
              className="st0"
              d="M108.9,349.2c-0.1,0-0.2,0-0.3,0c-1.4-0.1-1.4,2.3,0,2.2c0.1,0,0.2,0,0.3,0
  C110.3,351.2,110.3,349.4,108.9,349.2z"
            />
            <path
              className="st0"
              d="M122.1,361.1c-0.7-1.5-1.9-2.3-3.2-1.9c-2.8-0.9-5.1,2.6-6,4.7c-1.2,2.6-2.1,6.7,0.7,8.6
  c3.8,2.6,7.3-1.5,8.5-4.8C122.7,365.5,123,363.2,122.1,361.1z M119.7,365.9c-0.3,1.1-0.7,2.2-1.3,3.2c-1.2,1.7-3.8,2.4-4.2-0.2
  c-0.3-1.8,0.4-3.9,1.3-5.5c0.4-0.7,0.9-1.4,1.5-2c0.1-0.1,0.3-0.3,0.4-0.4c0,0.9,1.1,1.8,2,1.2
  C119.9,361.8,119.8,365.3,119.7,365.9z"
            />
            <path
              className="st0"
              d="M138.7,368.9c-1.6-4,0.5-8.8-2.2-12.7c-0.4-0.6-1.2-0.9-2-0.5c-2.4,1.4-4.4,3.6-5.9,6.2
  c-0.1-1.5-0.2-3-0.3-4.6c-0.1-0.8-1.5-1.2-1.6-0.2c0,0.1,0,0.1,0,0.2l0,0c0,0,0,0.1,0,0.1c0,0.4-0.1,0.9-0.1,1.3
  c-0.1,2.8,0,5.7-0.3,8.5c-0.5,1.6-0.8,3.2-0.9,4.7c-0.1,1.5,2.3,1.8,2.6,0.3c0.1-0.5,0.2-1,0.2-1.4c0.8-4.3,2.9-9.2,6.4-11.8
  c1.3,3.3-0.2,7.3,1.1,10.7C136.6,371.4,139.4,370.6,138.7,368.9z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M694.7,219c-0.2-1.1-1.5-0.8-1.8,0c0,0,0,0-0.1,0c-1.2,8.6-1.5,17.3-2.7,25.9c-1.2,8.2-2.2,16.3-2.1,24.6
  c0,1.9,2.9,1.9,2.9,0c-0.2-9.3,1.1-18.4,2.4-27.6C694.3,234.5,695.8,226.4,694.7,219z"
            />
            <path
              className="st0"
              d="M708.5,212.7c-3.2-1.8-6.7-0.3-9.9,1c-5.4,2.3-10.6,4.9-16.1,6.8c0,0,0,0,0,0c-1.3,0.3-0.9,2.6,0.6,2.1
  c4.6-1.4,9-3.4,13.4-5.2c2.4-1,6.4-3.3,9.3-2.8c-0.1,1.1,1.4,2.2,2.3,1.1c0.2-0.3,0.5-0.6,0.7-0.9
  C709.3,214.2,709.3,213.2,708.5,212.7z"
            />
            <path
              className="st0"
              d="M706.1,259.9c-3.7-1.3-9.9,2.8-12.9,4.4c-4.6,2.4-9.2,5.8-14.1,7.5c-0.9,0.3-0.8,1.7,0.2,1.7
  c3.8-0.1,8.1-3.5,11.3-5.1c4.3-2.2,10-6.1,15.1-5.8C707.3,262.6,707.4,260.4,706.1,259.9z"
            />
            <path
              className="st0"
              d="M730.1,252c-2.3,1.3-3.1,0.9-3.6-1.8c-0.4-2.1-0.3-4.3-0.2-6.5c0.2-3.5,0.7-6.9,1.2-10.4
  c0.2-1.8-2.4-2.6-2.7-0.7c-0.6,3.5-1.2,7-2.1,10.4c-1.7-0.9-4.3-0.7-6.5,1c-3.8,2.9-7.8,9.9-4.9,14.6c2.6,4.3,6.5,0.9,8.5-2
  c1.5-2.2,2.7-4.6,3.7-7.2c0,0.2,0,0.3,0,0.5c0.6,4.8,3.8,7.9,8.1,4.2C732.9,253.1,731.4,251.3,730.1,252z M718.5,253.7
  c-0.6,1-1.4,2.8-2.4,3.4c-3.2,2-3.5-2-3.1-4c0.3-1.8,1.3-3.6,2.3-5.1c0.6-0.9,1.3-1.7,2.1-2.4c1.5-1.6,3.1-1.6,4.6,0
  C721.1,248.4,720,251.1,718.5,253.7z"
            />
            <path
              className="st0"
              d="M743.1,246.9c-1.6,1.4-5.4,6.9-7.6,4.1c-0.3-0.4-0.5-0.9-0.6-1.4c3-0.9,5.3-3.7,5.8-6.9
  c0.5-3.3-2.2-4.5-4.7-2.5c-3.1,2.5-4.9,8.8-2.6,12.3c3.6,5.3,9.1-0.9,11.7-3.7C746.2,247.5,744.4,245.8,743.1,246.9z M736.8,242.7
  c0.2-0.3,1.5-1.7,1.8-1.5c0.5,0.3,0.1,1.9,0,2.3c-0.5,2.1-1.9,3.9-3.8,4.7C734.9,246.2,735.8,243.9,736.8,242.7z"
            />
            <path
              className="st0"
              d="M759.7,245.4c-1.4,0.9-4.8,5.1-5.3,1.9c-0.4-2.2,0.2-4.5,0.1-6.7c-0.1-0.9-1-1.5-1.7-1.3c0,0,0-0.1,0-0.1
  c0-0.2-0.1-0.4-0.3-0.4c-4.4-0.7-11.3,9-8.8,12.9c1.6,2.4,4.7,1,6.1-0.7c0.7-0.9,1.3-2,1.7-3c0.2,1.1,0.6,2,1.4,2.7
  c2.9,2.6,6.4-1.4,8.4-3.2C762.5,246.5,761,244.5,759.7,245.4z M745.7,250.6c-1.6-0.9,1.1-5.4,1.6-6.4c0.6-1,1.4-2,2.2-2.9
  c0.4-0.4,0.9-0.8,1.4-1.2c0.6-0.4,0.9-0.7,1-0.4c0,0-0.1,0.1-0.1,0.1C751,241.4,748.4,252.1,745.7,250.6z"
            />
            <path
              className="st0"
              d="M769.8,245.4c-0.2-1.6-1.7-2.5-2.9-3.3c-0.4-0.3-2-0.9-2.3-1.3c-0.7-1.2,0.4-3,1.5-4.2
  c0.4,0.5,1.3,0.3,1.4-0.4c0.1-0.4,0.1-0.8,0.1-1.2c0-0.7-0.7-1-1.3-0.7c-2.4,1.1-5,4.5-4,7.3c0.3,0.9,1,1.3,1.8,1.8
  c0.7,0.4,1.6,0.8,2.1,1.4c0.7,0.3,0.9,0.8,0.7,1.5c-0.5,1.1-1.4,1.6-2.8,1.4c-1.6-1-3,1.5-1.4,2.4
  C765.7,251.9,770.3,248.9,769.8,245.4z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M600,525c-0.3-1.4-2.5-1.4-2.8,0c-1.7,8.6-4.5,16.8-7.5,24.9c-1.4-9.3,0-18.8-1-28.2c-0.2-1.6-2.3-2-2.8-0.4
  c-3.2,9.1-5.2,18.7-7.2,28.1c-0.6,3-5.3,18.6-0.5,20.2c1.5,0.5,2.1-1.8,0.6-2.3c0.3,0.1,0.1-2.2,0.1-3c0.1-1.9,0.4-3.8,0.7-5.6
  c0.8-4.7,1.9-9.5,3-14.1c1.1-4.8,2.2-9.7,3.6-14.5c0,8.6-0.6,17.2,1.7,25.6c0.4,1.5,2.3,1.3,2.8,0c2.6-7.1,5.3-14.2,7.3-21.5
  c0,10.6-3.3,21.3-1.2,32c0.4,1.8,3.2,1.1,2.8-0.8C596.9,551.9,602.9,538.5,600,525z"
            />
            <path
              className="st0"
              d="M618.3,557.7c-0.1,0.2-0.5,1.1-0.8,1.4c0,0-0.1-0.1-0.2-0.2c-0.6-0.7-0.9-2-1.1-2.8c-0.5-1.6-0.8-3.3-1.4-4.9
  c-0.1-0.3-0.3-0.5-0.4-0.6c0.1-1.4,0.2-2.6-0.1-4c-0.1-0.3-0.4-0.5-0.7-0.5c-2.9-0.1-5,2.8-6.4,4.9c-1.5,2.3-3.5,6-2.7,8.9
  c0.7,2.6,3.4,3,5.4,1.4c1.5-1.3,2.6-3.1,3.4-5.1c0.4,1.5,0.9,3,1.7,4.3c2,3,4.6,1.3,5.9-1.4C621.5,557.5,619.2,556.1,618.3,557.7z
   M609.4,557.3c-0.3,0.5-1.5,2.8-2.4,2.4c-0.7-0.3-0.3-2-0.2-2.5c0.4-2.3,1.5-4.5,2.8-6.4c0.6-0.9,1.4-1.9,2.3-2.5
  c1.7-1.2,1.5,0.4,1.5,1.9c-0.6,0-1.2,0.3-1.4,1C611.3,553.3,610.5,555.4,609.4,557.3z"
            />
            <path
              className="st0"
              d="M631.5,544.7c-2.6,0.3-4.2,1.6-5.2,3.4c-0.1-0.7-0.2-1.5-0.3-2.2c-0.2-0.9-1.4-0.7-1.6,0c0,0,0,0,0,0
  c-0.8,4.3-0.3,8.9-0.7,13.2c-0.1,1.4,2.2,1.7,2.5,0.3c0.8-3.5,0.6-11.4,5.4-12C633.3,547.3,633.3,544.5,631.5,544.7z"
            />
            <path
              className="st0"
              d="M639.4,531.1c-0.1-1-1.3-1-1.6-0.2c0,0,0,0,0,0c-1.4,9.5-3.1,19.5-2.9,29.2c0,1.8,2.7,1.8,2.7,0
  C637.6,550.5,640,540.7,639.4,531.1z"
            />
            <path
              className="st0"
              d="M644.2,553.4c-1.7-0.3-3.3-0.9-4.9-1.6c1.7-2.5,3.1-5.2,4.6-7.7c0.5-0.7-0.4-2-1.3-1.1
  c-2.7,2.3-3.9,5.9-6.2,8.5c-0.6,0.6-0.5,1.7,0.3,2.1c2.1,1.2,4.5,2.1,6.9,2.6C645.3,556.5,646.1,553.7,644.2,553.4z"
            />
            <path
              className="st0"
              d="M657.5,548.1c-1.2,1.2-4.5,5.2-6.5,4.3c-0.7-0.3-1-1-0.9-1.8c2.6-0.6,5.2-3.8,5.6-5.9
  c0.1-0.6-0.1-1.3-0.8-1.4c-3-0.7-5.9,2.2-7,5.2c0,0,0,0-0.1,0c-0.7-0.4-1.3,0.5-0.8,1.1c0.2,0.2,0.4,0.4,0.5,0.5
  c-0.1,1,0,2,0.5,2.8c2.8,5.3,9-0.1,11.5-2.8C660.7,548.8,658.8,546.8,657.5,548.1z M652.9,545.9c-0.4,0.8-1.1,1.7-2,2.2
  C651.5,547.2,652.2,546.4,652.9,545.9z"
            />
            <path
              className="st0"
              d="M667.5,552.3c-4.1,2.8-2.7-9.4-2.6-9.9c0.6-3.2,1.5-6.3,1.1-9.6c-0.1-1.1-1.7-1.2-1.8,0c-0.1,1.1-0.2,2-0.4,3
  c-0.9,5-3.1,10.2-1.6,15c0.9,3,3.5,6.1,6.6,3.7C670.3,553.6,669,551.3,667.5,552.3z"
            />
            <path
              className="st0"
              d="M668.9,539.6c-3.6-0.9-6.9,1.2-10.2,2.4c-1,0.4-0.6,1.9,0.4,1.6c2.9-0.8,6.1-2.6,9.1-1.6
  C669.7,542.5,670.4,540,668.9,539.6z"
            />
            <g>
              <path
                className="st0"
                d="M676,546.2c-0.3-1.7-0.7-3.3-1.5-4.7c-0.4-0.7-1.6-0.2-1.3,0.6c0.5,1.2,0.8,2.5,0.9,3.8
    c0,0.6,0.1,1.2,0.1,1.8c0,0,0,0.1,0,0.1c-0.1,0.1-0.1,0.3-0.1,0.5c0,0.1,0,0.2,0,0.3c0,0,0-0.1,0.1-0.1c0,0.1,0,0.2-0.1,0.2
    c0,0.1,0,0.1,0,0.2c0.1,0.9,1.3,1.7,2,0.8C676.8,548.6,676.1,547.1,676,546.2z"
              />
              <path
                className="st0"
                d="M674.1,548.4C674.1,548.4,674.1,548.4,674.1,548.4C674.1,548.5,674.1,548.5,674.1,548.4z"
              />
            </g>
            <path
              className="st0"
              d="M675.8,531.3c-0.1,0-0.2,0-0.3,0c-0.8-0.1-1.6,0.3-1.6,1.2c0,0.9,0.8,1.3,1.6,1.2c0.1,0,0.2,0,0.3,0
  C677,533.4,677,531.5,675.8,531.3z"
            />
            <path
              className="st0"
              d="M691.8,546.8c-0.9-0.9-0.8-2.4-1-3.6c-0.2-1.4-0.6-2.6-1.4-3.8c-0.3-0.5-1-0.9-1.6-0.7
  c-2.6,0.9-4.5,2.9-5.9,5.2c-0.1-1.1-0.2-2.1-0.3-3.2c0-0.9-1.4-1.2-1.6-0.2c-0.1,0.5-0.1,0.7-0.1,1.2c0,0,0,0,0,0.1
  c-0.1,2.2,0.1,4.5-0.1,6.7c-0.1,1.6,2,1.6,2.6,0.3c1-2.4,2.7-5.5,5.1-6.9c0.9,2.4,0.2,5.3,2.6,7
  C691.5,549.9,693,547.9,691.8,546.8z"
            />
            <path
              className="st0"
              d="M703.1,537.2c-0.1-1.1-1.4-1.6-2.2-1.1c-0.1,0-0.2,0-0.3,0c-3.3,0.8-10.1,7.8-6.3,11.1c2.8,2.4,5-0.1,6.5-3.2
  c0.2,4.2,0,8.4-0.7,12.5c-0.6,3.2-2,6.1-4.8,7.9c-2.8,1.8-8.1,2.9-9.3-1.3c-0.5-1.8-3.4-1-2.8,0.8c2,6.8,10.5,5.8,15.1,2
  C705.7,559.5,704,545.8,703.1,537.2z M698,544.3c-4.4,3.1-1.6-2.4-1-3.3c0,0,3.5-4.3,3.1-2.7c0,0.2,0,0.3,0.1,0.4
  C699.8,540.8,699.2,543.5,698,544.3z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M702.9,412.5c-6.6,1-12.9,3.6-19.2,5.9c-0.1-10.2,2.6-20.8,4.2-30.8c0.7-4.4,1.3-8.7,2.2-13.1
  c0.5-2.5,1.2-5.2-0.1-7.6c-0.5-0.9-2-0.3-1.7,0.7c1,3.5-1,7.5-1.6,11c-1,4.9-1.7,9.9-2.5,14.8c-1.5,8.8-3.8,18-3.4,27
  c0,0.9,0.9,1.7,1.8,1.4c7-2.3,13.9-4.6,20.9-6.9C705.2,414.5,704.5,412.3,702.9,412.5z"
            />
            <path
              className="st0"
              d="M720.3,398.8c0-0.1,0-0.3,0-0.5c0-0.3-0.3-0.6-0.6-0.6c-3.5-0.3-6.3,4.4-7.3,7.1c-1.2,3-1.7,7.6,2,9.1
  C721.6,416.9,724.7,402.9,720.3,398.8z M715,411.5c-2.3-1.1-1.1-5-0.4-6.7c0.5-1.3,1.2-2.7,2.1-3.8c0.3-0.4,0.7-0.7,1-1.1
  c0,0.3,0.2,0.5,0.4,0.8C720.9,403,719.3,413.6,715,411.5z"
            />
            <path
              className="st0"
              d="M733.3,406.5c-1,0.9-2.8,3.3-4.3,3.2c-2-0.2-1.3-3.7-1-4.9c0.4-1.4,3.7-7.9,5.2-4.8c0.3,0.5,1.1,0.1,0.8-0.5
  c-2.5-5.2-7.5,2.4-8.2,5.2c-0.6,2.4-0.9,5.8,1.7,7.1c3,1.6,5.9-1.5,7.8-3.5C736.3,407.1,734.6,405.4,733.3,406.5z"
            />
            <path
              className="st0"
              d="M751.7,399.1c-1.1,2-2.4,4.2-4,5.8c-0.3,0.3-1.1,1.2-1.5,1.2c-1.3,0-1.1-1.3-1.1-2.1c0-1.1,0.4-2.3,0.5-3.4
  c0.1-1.2-1.6-1.8-2.3-1c-1.6,1.8-3.1,4.4-5.2,5.7c0,0-1.1,0.6-0.9,0.8c-0.6-0.4,0.2-3.3,0.4-3.8c1.2-3.3,5-6.2,8.2-3.4
  c0.7,0.6,1.6-0.3,1-1c-5.3-5.7-14.3,2.8-11.9,9.1c1.4,3.6,4.9,0.6,7.6-2.2c-0.1,2.5,0.5,4.9,3.7,4.4c3.7-0.6,6.6-5.6,8-8.7
  C754.8,398.9,752.6,397.5,751.7,399.1z"
            />
            <path
              className="st0"
              d="M764.5,404c-2.9,3.9-4.7-3.4-4.7-4.6c-0.1-2.3,0.3-4.6,0.8-6.9c0.9-4,2.3-7.8,3.2-11.8
  c0.4-1.1-1.4-1.6-1.7-0.5c-2.1,6.7-6.9,16-4.1,23.1c1.7,4.3,6,6.5,8.8,2C767.6,403.9,765.5,402.8,764.5,404z"
            />
            <path
              className="st0"
              d="M765.6,391.2c-2.2-0.3-4.6,0.6-6.7,1.2c-1.1,0.4-2.3,0.7-3.4,1.1c-0.4,0.1-0.9,0.2-1.3,0.3
  c-0.1,0.1-0.2,0.1-0.3,0.1c-0.2,0-0.4,0.1-0.4,0.4c0,0.2,0.2,0.6,0.1,0.4c0.1,0.3,0.4,0.5,0.7,0.5c3.5,0.3,7.1-2.5,10.6-1.7
  C766.5,393.8,767.1,391.4,765.6,391.2z"
            />
            <path
              className="st0"
              d="M771.9,396.2c-0.2-0.8-0.3-2.1-1-2.6c-0.4-0.3-0.8,0.1-0.8,0.5c-0.1,0.9,0.2,2,0.2,2.8c0.1,1,0,2.1,0.4,3
  c0.4,0.9,2.1,0.5,1.9-0.5C772.5,398.3,772.2,397.2,771.9,396.2z"
            />
            <path
              className="st0"
              d="M772.1,386.9c0.3,0.3-0.1-0.1-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0,0,0c0,0,0,0,0,0l0,0
  c-0.2-0.1-0.5-0.2-0.7-0.2c-0.7,0.1-1,0.7-1.1,1.3c-0.2,1,0.8,1.5,1.5,1.1C772.2,388.9,772.7,387.6,772.1,386.9z"
            />
            <path
              className="st0"
              d="M781.3,391.3c-0.2-0.2-0.4-0.3-0.6-0.2c-0.4,0.1-0.7,0.4-1.1,0.6c0,0,0,0-0.1,0c-0.2,0.1-0.4,0.3-0.5,0.5
  c-1.1,1.1-1.8,2.6-2.2,3.9c-0.5,2,0.2,4.3,2.6,4.1c2.8-0.2,5.3-2.6,5.2-5.5C784.7,392.6,783.2,391.3,781.3,391.3z M782,395.7
  c-0.2,0.8-0.7,1.3-1.4,1.7c-0.3,0.2-1.3,0.8-1.7,0.5c-0.4-0.3,0.1-2,0.2-2.4c0.1-0.4,0.3-0.9,0.5-1.3c0.4,0.2,0.8,0.2,1.3,0
  C782.1,393.6,782.3,394.8,782,395.7z"
            />
            <path
              className="st0"
              d="M800.3,399.5c-3.5-1.1,0.8-9.5-4.8-9.3c-2.3,0.1-4.2,2.1-5.6,4.5c0-0.2,0-0.4,0-0.6c0-0.8-0.4-2.3-0.1-3.1
  c0.4-1-1-1.3-1.5-0.6c-0.6,0.9-0.2,3.1-0.2,4.1c0,2.2,0,4.3-0.5,6.5c-0.3,1.3,1.7,1.9,2.1,0.6c0.5-2,1.4-4,2.5-5.8
  c0.6-1.1,3.1-4.7,4.1-2.5c0.7,1.5,0.1,3.7,0.5,5.3c0.4,1.6,1.3,2.7,2.9,3.3C801.2,402.4,801.8,400,800.3,399.5z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M301.7,158.3c-9.4-4.8-18.7-9.9-25.8-17.9c-6.9-7.9-12.5-19.1-15.3-29.2c-0.2-0.6-1.1-0.5-1.1,0.1
  c0.3,4.9,3,9.8,5,14.2c2.4,5.2,5,10.2,8.6,14.7c7.2,9.1,17.2,14.9,27.3,20.1C301.8,161.1,303.1,159,301.7,158.3z"
            />
            <path
              className="st0"
              d="M270.7,112.8c-4.5-2-9.2-3.6-13.9-5.4c-0.4-0.2-1,0.1-1.2,0.5c-0.9,1.9-1.2,4.1-1.3,6.2
  c-0.1,1.5-0.4,3.7,0.6,4.9c0.1,0.1,0.3,0.1,0.4-0.1c0.7-1,0.5-2.5,0.6-3.7c0.2-1.8,0.4-3.7,1.1-5.4c4.2,1.9,8.5,3.5,12.7,5.1
  C271,115.5,271.9,113.4,270.7,112.8z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M242.9,274.2c-17.5-4.2-35.3-7.3-52.5-12.7c-13.9-4.3-27.5-9.6-38.6-19c0.1-0.1,0.1-0.3-0.1-0.5
  c-0.7-0.4-1.4-0.9-2-1.4c-0.7-0.6-1.4-1.3-2-1.9c-0.6-0.7-1.8,0.2-1.3,1c8.5,12.4,25.3,18.2,38.9,22.9
  c18.4,6.3,37.7,10.5,56.9,13.9C243.7,276.8,244.4,274.6,242.9,274.2z"
            />
            <path
              className="st0"
              d="M162.6,239c-6.1-0.8-12.5-2.8-18.7-2.1c-0.8,0.1-1.6,0.8-1.3,1.7c1.5,4.3,2.7,8.5,3.6,12.9
  c0.2,1.1,1.8,0.7,1.8-0.2h0c0-0.9-0.1-1.9-0.2-2.8c0-0.4,0-0.7,0.1-1.1c0-0.2-0.1-0.3-0.3-0.3c-0.5-2.5-1.2-5.1-2-7.5
  c5.7,0,11.2,1.7,16.9,2.2C164.3,241.9,164.3,239.2,162.6,239z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M161.1,434.1c-24.7-0.5-48.2-11-61.1-32.7c-0.5-1.2-2.3-0.1-1.7,1c11.6,22.3,38.2,35.4,62.9,34.2
  C162.6,436.5,162.7,434.2,161.1,434.1z"
            />
            <path
              className="st0"
              d="M118.4,403.5c-6.9-1-13.2-3.4-20-4.9c-0.9-0.2-1.7,0.4-1.7,1.3c0,2-2.1,11.2,1.3,11.3c0.2,0,0.3-0.1,0.3-0.3
  c0.4-1.4,0.1-2.9,0.2-4.4c0.1-1.6,0.4-3.3,0.6-4.9c6.1,2,12.5,4.1,18.8,4.6C119.6,406.4,120,403.8,118.4,403.5z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M555.9,550.1c-15-3.5-28.7-9.5-40.6-19.5c-5.8-4.9-11-10.4-15.5-16.5c-3.8-5-6.6-10.5-10-15.8
  c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0,0.1-0.1c-0.7-0.9-1.3-1.7-2-2.6c-0.4-0.6-1.4-0.2-1.2,0.5c2.1,7.1,6.8,13.8,11.1,19.7
  c4.6,6.2,9.9,12,15.9,17c11.7,9.9,26.1,17.4,41.3,19.7C556.9,552.9,557.6,550.5,555.9,550.1z"
            />
            <path
              className="st0"
              d="M561.3,551.1c-2.7-5.9-7-11-11.3-15.8c-1.2-1.4-3,0.6-2,2c3.4,4.4,7.1,8.3,9.8,13.1
  c-4.1,0.1-8.3,0.3-12.4,0.8c-3.3,0.4-6.9,0.7-9.6,2.8c-0.3,0.2,0,0.6,0.3,0.6c3.9,0.4,8-1,11.9-1.3c4.1-0.3,8.1-0.3,12.2-0.2
  C561.3,553.3,561.8,552.1,561.3,551.1z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M654.9,379.1c-19.6-6.1-37.7-18-54.9-29.1c-16.8-10.9-32.7-23.6-42.4-41.3c-0.3-0.8-1.5-0.2-1.3,0.6
  c1.9,8.7,9.4,16.3,15.6,22.3c7.5,7.2,15.8,13.6,24.4,19.4c9.2,6.1,18.7,11.8,28.3,17.4c9.4,5.5,19.1,10.6,29.6,13.4
  C655.9,382.1,656.6,379.6,654.9,379.1z"
            />
            <path
              className="st0"
              d="M651.2,369.2c-1-1.5-3.1-0.2-2.4,1.4c1.3,2.9,3.7,5.4,4.2,8.7c-2.6,0.7-4.9,2.2-7.4,2.9
  c-1.8,0.5-3.6,1.5-5.3,1.9c-0.3,0.1-0.3,0.6,0.1,0.6c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.5-0.1,1.6,0,2.2-0.1c1.2-0.1,2.3-0.3,3.5-0.6
  c3-0.5,5.8-1.9,8.8-2.4c0.6-0.1,1-0.8,1-1.4C656,376.3,653.5,372.4,651.2,369.2z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M659.7,250.6c-14,3.6-28.2,5.8-42.6,5.7c-7.3,0-14.8-0.4-22.1-1.5c-6.4-1.1-12.8-2.9-19.4-2.7c0,0,0,0,0,0
  c-0.8,0-1.1,1.3-0.2,1.4c14.4,2.1,28,5.3,42.6,5.4c14.3,0,28.6-1.9,42.4-5.8C662,252.7,661.3,250.2,659.7,250.6z"
            />
            <path
              className="st0"
              d="M661.8,251.1c-5.4-1-10.1-3.6-15.4-4.9c-0.6-0.3-1.2,0.7-0.5,1.2c4.1,2.5,8.8,4.7,13.6,6
  c-2,3.7-4.8,6.6-7.9,9.5c-1.4,1.3,0.7,3.3,2.1,2.1c3.7-3.5,7.2-7.3,9.2-12.1C663,252.1,662.5,251.2,661.8,251.1z"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default SVG;
